<template>
  <div class="page-path">
    <main class="main-path">
      <header class="path-header">
        <div class="left">
          <h2>职业路径</h2>
          <button class="gridback"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.88501 4.96667L5.57567 6.65733L4.63301 7.6L1.33301 4.3L4.63301 1L5.57567 1.94267L3.88501 3.63333H8.66634C10.0808 3.63333 11.4374 4.19524 12.4376 5.19543C13.4378 6.19562 13.9997 7.55218 13.9997 8.96666C13.9997 10.3812 13.4378 11.7377 12.4376 12.7379C11.4374 13.7381 10.0808 14.3 8.66634 14.3H2.66634V12.9667H8.66634C9.72721 12.9667 10.7446 12.5452 11.4948 11.7951C12.2449 11.0449 12.6663 10.0275 12.6663 8.96666C12.6663 7.9058 12.2449 6.88838 11.4948 6.13824C10.7446 5.38809 9.72721 4.96667 8.66634 4.96667H3.88501Z" />
            </svg>返回</button>
        </div>
        <div class="right headerNav">
          <button class="headerNav__item">平面/品牌设计师</button>
          <button class="headerNav__item">视觉/运营设计师</button>
          <button class="headerNav__item">商业插画师</button>
          <button class="headerNav__item">界面/交互设计师</button>
        </div>
      </header>
      <nav class="menu">
        <div class="menu__item">
          <div class="menu__item-textwrap">
            <div class="menu__item-text">
              <span class="menu__item-text-outline">GRAPHIC/BRAND</span>
              <div class="loop-holder">
                <div class="loop-holder__text">GRAPHIC/BRAND DESIGNER GRAPHIC/BRAND DESIGNER</div>
                <div class="loop-holder__text">GRAPHIC/BRAND DESIGNER GRAPHIC/BRAND DESIGNER</div>
                <div class="loop-holder__text">GRAPHIC/BRAND DESIGNER GRAPHIC/BRAND DESIGNER</div>
              </div>
            </div>
            <div class="menu__item-text-ZH">
              <span class="menu__item-number"></span>
              <span class="text">平面/品牌<span>设计师</span></span>
              <a class="menu__item-link">进入学习路径</a>
            </div>
          </div>
        </div>
        <div class="menu__item">
          <div class="menu__item-textwrap">
            <div class="menu__item-text">
              <span class="menu__item-text-outline">VISUAL/MARKETING</span>
              <div class="loop-holder">
                <div class="loop-holder__text">VISUAL/MARKETING DESIGNER VISUAL/MARKETING DESIGNER</div>
                <div class="loop-holder__text">VISUAL/MARKETING DESIGNER VISUAL/MARKETING DESIGNER</div>
                <div class="loop-holder__text">VISUAL/MARKETING DESIGNER VISUAL/MARKETING DESIGNER</div>
              </div>
            </div>
            <div class="menu__item-text-ZH">
              <span class="menu__item-number"></span>
              <span class="text">视觉/运营<span>设计师</span></span>
              <a class="menu__item-link">进入学习路径</a>
            </div>
          </div>
        </div>
        <div class="menu__item">
          <div class="menu__item-textwrap">
            <div class="menu__item-text">
              <span class="menu__item-text-outline">ILLUSTRATOR</span>
              <div class="loop-holder">
                <div class="loop-holder__text">ILLUSTRATOR ILLUSTRATOR ILLUSTRATOR ILLUSTRATOR</div>
                <div class="loop-holder__text">ILLUSTRATOR ILLUSTRATOR ILLUSTRATOR ILLUSTRATOR</div>
                <div class="loop-holder__text">ILLUSTRATOR ILLUSTRATOR ILLUSTRATOR ILLUSTRATOR</div>
              </div>
            </div>
            <div class="menu__item-text-ZH">
              <span class="menu__item-number"></span>
              <span class="text">商业<span>插画师</span></span>
              <a class="menu__item-link">进入学习路径</a>
            </div>
          </div>
        </div>
        <div class="menu__item">
          <div class="menu__item-textwrap">
            <div class="menu__item-text">
              <span class="menu__item-text-outline">VISUAL/MARKETING</span>
              <div class="loop-holder">
                <div class="loop-holder__text">UI/UX DESIGNER UI/UX DESIGNER UI/UX DESIGNER</div>
                <div class="loop-holder__text">UI/UX DESIGNER UI/UX DESIGNER UI/UX DESIGNER</div>
                <div class="loop-holder__text">UI/UX DESIGNER UI/UX DESIGNER UI/UX DESIGNER</div>
              </div>
            </div>
            <div class="menu__item-text-ZH">
              <span class="menu__item-number"></span>
              <span class="text">界面/交互<span>设计师</span></span>
              <a class="menu__item-link">进入学习路径</a>
            </div>
          </div>
        </div>
      </nav>
      <div class="page page--preview">
        <div class="gridwrap">
          <div class="grid grid--layout-1">
            <div class="grid__title">
              <h2>平面/品牌<span>设计师</span></h2>
              <h3>GRAPHIC/BRAND</h3>
              <span class="path-icon">
                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M32.4997 0V14.9956L27.5002 15.0001V0H32.4997ZM17.5725 22.4716C25.254 19.3021 34.143 19.0531 42.4313 22.4664C50.7075 25.8894 56.8192 32.3386 60 39.9999C56.5703 48.2575 50.1053 54.3513 42.4275 57.5245C34.746 60.6985 25.8547 60.9475 17.5687 57.5298C9.2925 54.1068 3.18375 47.6567 0 39.9999C3.42975 31.7379 9.8925 25.6449 17.5725 22.4716ZM17.4998 40C17.4998 46.9045 23.0955 52.5003 30 52.5003C36.9068 52.5003 42.5003 46.9045 42.5003 40C42.5003 33.091 36.9068 27.5004 30 27.5004C23.0955 27.5004 17.4998 33.091 17.4998 40ZM35.0003 40C35.0003 42.7645 32.7638 45.0002 30 45.0002C27.2385 45.0002 24.9998 42.7645 24.9998 40C24.9998 37.2362 27.2385 35.0004 30 35.0004C32.7638 35.0004 35.0003 37.2362 35.0003 40ZM47.5148 19.3456L54.9901 8.6671L50.8936 5.80133L43.4183 16.4746L47.5148 19.3456ZM9.10645 5.80133L16.5839 16.4799L12.4874 19.3509L5.00995 8.6671L9.10645 5.80133Z" fill="#99A0B3" />
                </svg>
              </span>
              <p>如果说，有一种设计被运用的最为广泛，几乎无处不在，那一定非平面设计莫属。平面设计在这个时代有了全新的定义，当平面不局限于纸的媒介，而是在一个特定二维布局内与人的信息沟通方式，信息的秩序、结构与重构则是平面设计师的价值所在。从品牌、导视系统，到海报、宣传册、包装等物料设计，平面设计师都在这个品牌大于一切的时代用自己独有的方式改变着人们的行为和消费。</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path1-0.jpg)">
              <!-- <p>标志设计</p> -->
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path1-1.jpg)">
              <p>海报设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path1-2.jpg)">
              <p>字体设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path1-3.jpg)">
              <p>网页设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path1-4.jpg)">
              <p>品牌设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path1-5.jpg)">
              <p>包装设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path1-6.jpg)">
              <p>书籍设计</p>
            </div>
          </div>
          <div class="grid grid--layout-2">
            <div class="grid__title">
              <h2>视觉/运营<span>设计师</span></h2>
              <h3>VISUAL/MARKETING</h3>
              <span class="path-icon"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M32.4997 0V14.9956L27.5002 15.0001V0H32.4997ZM17.5725 22.4716C25.254 19.3021 34.143 19.0531 42.4313 22.4664C50.7075 25.8894 56.8192 32.3386 60 39.9999C56.5703 48.2575 50.1053 54.3513 42.4275 57.5245C34.746 60.6985 25.8547 60.9475 17.5687 57.5298C9.2925 54.1068 3.18375 47.6567 0 39.9999C3.42975 31.7379 9.8925 25.6449 17.5725 22.4716ZM17.4998 40C17.4998 46.9045 23.0955 52.5003 30 52.5003C36.9068 52.5003 42.5003 46.9045 42.5003 40C42.5003 33.091 36.9068 27.5004 30 27.5004C23.0955 27.5004 17.4998 33.091 17.4998 40ZM35.0003 40C35.0003 42.7645 32.7638 45.0002 30 45.0002C27.2385 45.0002 24.9998 42.7645 24.9998 40C24.9998 37.2362 27.2385 35.0004 30 35.0004C32.7638 35.0004 35.0003 37.2362 35.0003 40ZM47.5148 19.3456L54.9901 8.6671L50.8936 5.80133L43.4183 16.4746L47.5148 19.3456ZM9.10645 5.80133L16.5839 16.4799L12.4874 19.3509L5.00995 8.6671L9.10645 5.80133Z" fill="#99A0B3" />
                </svg></span>
              <p>视觉设计师是最广泛存在于跨国公司，大型公司，互联网公司的职位，是传统平面设计师的进化方向。内容领域不仅包含标志设计、包装设计、字体设计、图像设计、广告设计等一切与产品和品牌视觉相关的设计纬度，在互联网时代下，更强调通过视觉形象传达给用户，同时兼具审美与营销思维，注重考虑用户需求和产品营销，也是驱动企业增长的刚性领域。</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path2-0.jpg)"></div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path2-1.jpg)">
              <p>标志设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path2-2.jpg)">
              <p>广告设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path2-3.jpg)">
              <p>三维设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path2-4.gif)">
              <p>动态设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path2-5.jpg)">
              <p>创意设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path2-6.jpg)">
              <p>场景设计</p>
            </div>

          </div>
          <div class="grid grid--layout-3">
            <div class="grid__title">
              <h2>商业<span>插画师</span></h2>
              <h3>ILLUSTRATOR</h3>
              <span class="path-icon"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M32.4997 0V14.9956L27.5002 15.0001V0H32.4997ZM17.5725 22.4716C25.254 19.3021 34.143 19.0531 42.4313 22.4664C50.7075 25.8894 56.8192 32.3386 60 39.9999C56.5703 48.2575 50.1053 54.3513 42.4275 57.5245C34.746 60.6985 25.8547 60.9475 17.5687 57.5298C9.2925 54.1068 3.18375 47.6567 0 39.9999C3.42975 31.7379 9.8925 25.6449 17.5725 22.4716ZM17.4998 40C17.4998 46.9045 23.0955 52.5003 30 52.5003C36.9068 52.5003 42.5003 46.9045 42.5003 40C42.5003 33.091 36.9068 27.5004 30 27.5004C23.0955 27.5004 17.4998 33.091 17.4998 40ZM35.0003 40C35.0003 42.7645 32.7638 45.0002 30 45.0002C27.2385 45.0002 24.9998 42.7645 24.9998 40C24.9998 37.2362 27.2385 35.0004 30 35.0004C32.7638 35.0004 35.0003 37.2362 35.0003 40ZM47.5148 19.3456L54.9901 8.6671L50.8936 5.80133L43.4183 16.4746L47.5148 19.3456ZM9.10645 5.80133L16.5839 16.4799L12.4874 19.3509L5.00995 8.6671L9.10645 5.80133Z" fill="#99A0B3" />
                </svg></span>
              <p>商业插画师可能是这个时代最令人向往的职业之一，工作自由、充满创意且收入颇丰。商业插画更偏向服务大众，帮助商业产品或品牌更好与用户沟通。现如今插画已成为重要设计表达形式：出挑的色彩、夸张的造型，可以兼容更多元的文化和群体，带来更强的视觉冲击和情感共鸣。不仅广受传统商业和影视的青睐，更因为互联网的普及及年轻态族群的消费兴起，即将占据设计领域的C位。</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path3-0.jpg)"></div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path3-1.jpg)">
              <p>商业插画</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path3-2.jpg)">
              <p>运营插画</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path3-3.jpg)">
              <p>潮流插画</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path3-4.gif)">
              <p>动态插画</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path3-5.jpg)">
              <p>矢量插画</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path3-6.jpg)">
              <p>二次元插画</p>
            </div>

          </div>
          <div class="grid grid--layout-4">
            <div class="grid__title">
              <h2>界面/交互<span>设计师</span></h2>
              <h3>UI/UX DESIGNER</h3>
              <span class="path-icon"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M32.4997 0V14.9956L27.5002 15.0001V0H32.4997ZM17.5725 22.4716C25.254 19.3021 34.143 19.0531 42.4313 22.4664C50.7075 25.8894 56.8192 32.3386 60 39.9999C56.5703 48.2575 50.1053 54.3513 42.4275 57.5245C34.746 60.6985 25.8547 60.9475 17.5687 57.5298C9.2925 54.1068 3.18375 47.6567 0 39.9999C3.42975 31.7379 9.8925 25.6449 17.5725 22.4716ZM17.4998 40C17.4998 46.9045 23.0955 52.5003 30 52.5003C36.9068 52.5003 42.5003 46.9045 42.5003 40C42.5003 33.091 36.9068 27.5004 30 27.5004C23.0955 27.5004 17.4998 33.091 17.4998 40ZM35.0003 40C35.0003 42.7645 32.7638 45.0002 30 45.0002C27.2385 45.0002 24.9998 42.7645 24.9998 40C24.9998 37.2362 27.2385 35.0004 30 35.0004C32.7638 35.0004 35.0003 37.2362 35.0003 40ZM47.5148 19.3456L54.9901 8.6671L50.8936 5.80133L43.4183 16.4746L47.5148 19.3456ZM9.10645 5.80133L16.5839 16.4799L12.4874 19.3509L5.00995 8.6671L9.10645 5.80133Z" fill="#99A0B3" />
                </svg></span>
              <p>界面/交互设计师在互联网设计领域，薪资最高当之无愧。不仅包含一个产品的用户行为流程设计和视觉表现，更决定整个产品的设计语言和调性表达。随着UXUI设计师人数的增长，市场对设计师提出的要求也越来越高，不仅要求要有专业的设计技能，同时拥有国际化的视野和掌握产品开发流程的全局观也称为衡量一个优秀设计师的重要标准。</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path4-0.jpg)"></div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path4-1.jpg)">
              <p>UI界面设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path4-2.jpg)">
              <p>UX交互设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path4-3.jpg)">
              <p>图形化设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path4-4.jpg)">
              <p>信息设计</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path4-5.jpg)">
              <p>用户体验</p>
            </div>
            <div class="grid__item" style="background-image: url(https://video.dinlab.cn/images/learningpath/path4-6.jpg)">
              <p>产品设计</p>
            </div>
          </div>
          <!-- <button class="gridback">back</button> -->
        </div><!-- /gridwrap -->
        <div class="content js">
          <div class="content__item content__item__1">
            <div class="jd">
              <div class="grid__jd">
                <h2>名企职位要求</h2>
                <p>左右滑动查看更多</p>
              </div>
              <div class="grid__jd__wrap">
                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path1-jd1.png" alt="JD">
                </div>
                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path1-jd2.png" alt="JD">
                </div>
                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path1-jd3.png" alt="JD">
                </div>
              </div>
            </div>
            <div class="step">
              <div class="step__title">
                <div class="step__pin">
                  <h4>必备能力要求</h4>
                  <h6>共 4 门课程</h6>
                  <p>扎实的色彩搭配能力、扎实的图形设计、扎实的版式设计能力、扎实的字体设计能力是构建平面设计师能力的基石。在此之上，还有更重要的信息逻辑思维能力：设计思维与创意思维在早期的建立，比任何一个技能都更加重要。建立正确的思维方法，学会灵活运用技能，面对任何工作和项目都游刃有余。</p>
                </div>

              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path1-step1.jpg" alt="西文字体">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path1-step1-mb.jpg" alt="西文字体">
                <!-- <a href="https://shimo.im/docs/CC9JDQV6GgQdvYQC/" target="_blank">学员作品→</a> -->
                <a href="https://www.dinlab.cn/course/565" target="_blank">更多了解课程→</a>
              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path1-step2n.jpg" alt="中文字体设计">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path1-step2-mbn.jpg" alt="中文字体设计">
                <a href="https://shimo.im/docs/16q8M6by9eFXWpk7" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/628" target="_blank">更多了解课程→</a>
              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path1-step3.jpg" alt="网格与版式">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path1-step3-mb.jpg" alt="网格与版式">
                <!-- <a href="https://shimo.im/docs/gO3ox1VDe7U7NDqD" target="_blank">学员作品→</a> -->
                <a href="https://www.dinlab.cn/course/635" target="_blank">更多了解课程→</a>
              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path1-step4.jpg" alt="标志与品牌">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path1-step4-mb.jpg" alt="标志与品牌">
                <a href="https://shimo.im/docs/25q5MXYVmGH9DOqD" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/622" target="_blank">更多了解课程→</a>
              </div>
            </div>
            <div class="coursebag">
              <div class="coursebag__title">
                <h4>竞争突围补给包</h4>
                <h6>共 4 门课程</h6>
                <p>平面设计领域的竞争更多会在审美、技法与个人风格等依赖项目及阅历积累层面的能力。可一旦结合C4D、TouchDesign，Motion Graphic Design等三维渲染、动态图形的新技术、新媒介，就会带你从二维竞争转向一个二维+三维+动态综合能力的竞争领域，竞争对手骤减，机遇也相应增加，而这也是年轻设计师最容易突围出圈的方式。</p>
              </div>
              <div class="coursebag__item">
                <img src="https://assets.dinlab.cn/staticPage/learningpath/202111/path1-course1.jpg" alt="C4D物体建模">
                <a href="https://shimo.im/docs/BSUFNhLdnG8jJnk8" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/631" target="_blank">更多了解课程→</a>
              </div>
              <div class="coursebag__item">
                <img src="https://assets.dinlab.cn/staticPage/learningpath/202111/path1-course2.jpg" alt="AIGC商业全流程">
                <!-- <a href="https://shimo.im/docs/yckKxYqKDqvGCxDJ/" target="_blank">学员作品→</a> -->
                <a href="https://www.dinlab.cn/course/634" target="_blank">更多了解课程→</a>
              </div>
            </div>
            <div class="buybuybuy">
              <h2>跟随路径学习 加速企业直推</h2>
              <h4>单独学习购买任何一项查漏补缺。</h4>
              <h5>也可 <a class="pathBuy1">购买</a> 完整路径，最高优惠<span> 500元！</span></h5>
              <img src="https://video.dinlab.cn/images/learningpath/path1-boy.png" alt="">
            </div>
          </div>
          <div class="content__item content__item__2">
            <div class="jd">
              <div class="grid__jd">
                <h2>名企职位要求</h2>
                <p>左右滑动查看更多</p>
              </div>
              <div class="grid__jd__wrap">
                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path2-jd1.png" alt="JD">
                </div>
                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path2-jd2.png" alt="JD">
                </div>
                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path2-jd3.png" alt="JD">
                </div>
              </div>
            </div>
            <div class="step">
              <div class="step__title">
                <div class="step__pin">
                  <h4>必备能力要求</h4>
                  <h6>共 4 门课程</h6>
                  <p>色彩、图形、版式、字体以及矢量插画能力必不可少。丰富的艺术性和全面的技法层能力是视觉设计师的基础，帮助你不局限于创意内容的表达。<br><br>走出校园后，许多人觉得学校所学，缺少与高速发展时代相对应的商业设计能力，无法在职业竞争中发挥作用。如果你想精进设计的商业价值，在项目与技法的刻意练习中形成自己风格，从而获得更好的机会，快速进入理想的设计团队，甚至未来成立自己的设计工作室。这条为你定制的视觉设计师学习路径将会是最高效的成长方式。</p>
                </div>

              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path2-step1.jpg" alt="西文字体">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path2-step1-mb.jpg" alt="西文字体">
                <!-- <a href="https://shimo.im/docs/CC9JDQV6GgQdvYQC/" target="_blank">学员作品→</a> -->
                <a href="https://www.dinlab.cn/course/565" target="_blank">更多了解课程→</a>
              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path2-step2n.jpg" alt="中文字体">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path2-step2-mbn.jpg" alt="中文字体">
                <a href="https://shimo.im/docs/16q8M6by9eFXWpk7" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/628" target="_blank">更多了解课程→</a>
              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path2-step3.jpg" alt="AI矢量插画">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path2-step3-mb.jpg" alt="AI矢量插画">
                <a href="https://shimo.im/docs/vgDp9V86wWRgRpkG/" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/184" target="_blank">更多了解课程→</a>
              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path2-step4.jpg" alt="C4D物体建模">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path2-step4-mb.jpg" alt="C4D物体建模">
                <a href="https://shimo.im/docs/KlkKVdvyG4UWwjqd" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/631" target="_blank">更多了解课程→</a>
              </div>
            </div>
            <div class="coursebag">
              <div class="coursebag__title">
                <h4>竞争突围补给包</h4>
                <h6>共 4 门课程</h6>
                <p>视觉领域的表现是最不应该被工具和形式束缚的，一切可以有效呈现视觉的新技术、新媒介都会赋能更好地展示，以达到商业传播的目的。<br><br>在持续的审美和项目阅历积累中，结合C4D、Motion Graphic Design、TouchDesign等三维渲染、动态图形以及编程设计的新技术、新媒介，会使你革新视觉呈现并且事半功倍，也会让你的创作更具科技感和未来感。扎实的基本功与领域发展的新理念，将会打破你后期发展的所有枷锁。</p>
              </div>
              <div class="coursebag__item">
                <img src="https://assets.dinlab.cn/staticPage/learningpath/202111/path1-course2.jpg" alt="AIGC商业全流程">
                <!-- <a href="https://shimo.im/docs/yckKxYqKDqvGCxDJ/" target="_blank">学员作品→</a> -->
                <a href="https://www.dinlab.cn/course/634" target="_blank">更多了解课程→</a>
              </div>
              <div class="coursebag__item">
                <img src="https://assets.dinlab.cn/staticPage/learningpath/202111/path2-course2.jpg" alt="TD新媒体设计">
                <a href="https://lux01cqxug.feishu.cn/docx/HDkgdlg0LoG9onxu6zich17GnJb" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/611" target="_blank">更多了解课程→</a>
              </div>
            </div>
            <div class="buybuybuy">
              <h2>跟随路径学习 加速企业直推</h2>
              <h4>单独学习购买任何一项查漏补缺。</h4>
              <h5>也可 <a class="pathBuy2">购买</a> 完整路径，最高优惠<span> 500元！</span></h5>
              <img src="https://video.dinlab.cn/images/learningpath/path2-boy.png" alt="">
            </div>
          </div>
          <div class="content__item content__item__3">
            <div class="jd">
              <div class="grid__jd">
                <h2>名企职位要求</h2>
                <p>左右滑动查看更多</p>
              </div>
              <div class="grid__jd__wrap">

                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path3-jd1.png" alt="JD">
                </div>
                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path3-jd2.png" alt="JD">
                </div>
                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path3-jd3.png" alt="JD">
                </div>
              </div>
            </div>
            <div class="step">
              <div class="step__title">
                <div class="step__pin">
                  <h4>必备能力要求</h4>
                  <h6>共 3 门课程</h6>
                  <p>思维能力，审美能力，造型能力，概括能力是成为插画师的关键。造型能力和概括能力，可以通过必要的绘画知识的习得来熟练表达各种形态的造型，从人物到场景，无论什么物体学会归纳抽象成几何形体，将会大大提高创作的效率，同时带来更强的商业价值点聚焦以及情感共鸣。<br><br>事实上，一份成熟的商业作品并不是审美满分或技法满分的，而是在商业价值与大众审美中做一个平衡取舍。因此，以商业目的为绘画的创作视角和思维是应该从一开始就培养和学习的。这条为你定制的商业插画师学习路径将会让你不再浪费时间走弯路，带你更快成为一枚优秀的商业插画师。</p>
                  </p>
                </div>

              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path3-step1.jpg" alt="商业插画入门">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path3-step1-mb.jpg" alt="商业插画入门">
                <a href="https://shimo.im/docs/yckKxYqKDqvGCxDJ/" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/175" target="_blank">更多了解课程→</a>
              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path3-step2.jpg" alt="扁平插画与思维">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path3-step2-mb.jpg" alt="扁平插画与思维">
                <a href="https://shimo.im/docs/NJkbEZ5y7xs0nXqR/" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/638" target="_blank">更多了解课程→</a>
              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path3-step3.jpg" alt="AI矢量插画">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path3-step3-mb.jpg" alt="AI矢量插画">
                <a href="https://shimo.im/docs/vgDp9V86wWRgRpkG/" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/184" target="_blank">更多了解课程→</a>
              </div>
            </div>
            <div class="coursebag">
              <div class="coursebag__title">
                <h4>竞争突围补给包</h4>
                <h6>共 4 门课程</h6>
                <p>职业插画师的必杀技，就是不断跨界，实现流量交叉。数字技术，让插画轻松实现动态化，拓展了插画的表现范畴。同时，插画与C4D三维设计的结合也使得作品吸睛程度大大提高，通过深化用户记忆，创造更大的商业效益。就个人品牌而言，更可以延展出动态插画、人物角色手办及潮玩设计，来为自己的插画作品附加更多维的表达和更全面的商业品牌价值。</p>
              </div>
              <div class="coursebag__item">
                <img src="https://assets.dinlab.cn/staticPage/learningpath/202111/path3-course1.jpg" alt="IP角色形象设计">
                <a href="https://shimo.im/docs/9Gc8Gw83GvCw6cVt" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/629" target="_blank">更多了解课程→</a>
              </div>
              <div class="coursebag__item">
                <img src="https://assets.dinlab.cn/staticPage/learningpath/202111/path3-course2.jpg" alt="动态IP表情包设计">
                <a href="https://lux01cqxug.feishu.cn/docx/RUbDdFBGvoONhzxFVPgcGS9FnAc" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/630" target="_blank">更多了解课程→</a>
              </div>
              <div class="coursebag__item">
                <img src="https://assets.dinlab.cn/staticPage/learningpath/202111/path3-course3.jpg" alt="AIGC商业全流程">
                <!-- <a href="https://shimo.im/docs/gO3ox1VDe7U7NDqD" target="_blank">学员作品→</a> -->
                <a href="https://www.dinlab.cn/course/634" target="_blank">更多了解课程→</a>
              </div>
            </div>
            <div class="buybuybuy">
              <h2>跟随路径学习 加速企业直推</h2>
              <h4>单独学习购买任何一项查漏补缺。</h4>
              <h5>也可 <a class="pathBuy3">购买</a> 完整路径，最高优惠<span> 500元！</span></h5>
              <img src="https://video.dinlab.cn/images/learningpath/path3-boy.png" alt="">
            </div>
          </div>
          <div class="content__item content__item__4">
            <div class="jd">
              <div class="grid__jd">
                <h2>名企职位要求</h2>
                <p>左右滑动查看更多</p>
              </div>
              <div class="grid__jd__wrap">
                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path4-jd1.png" alt="JD">
                </div>
                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path4-jd2.png" alt="JD">
                </div>
                <div class="grid__jd__item">
                  <img src="https://assets.dinlab.cn/staticPage/learningpath/path4-jd3.png" alt="JD">
                </div>
              </div>
            </div>
            <div class="step">
              <div class="step__title">
                <div class="step__pin">
                  <h4>必备能力要求</h4>
                  <h6>共 2 门课程</h6>
                  <p>除去对软件工具的熟悉，四大必备能力包括：熟知设计流程，掌握跨职能沟通的协作能力；理解设计思维，具备设计师的敏锐的洞察力；专业的设计交付，精通推动项目落地的执行力；打造设计故事，完整阐述每个设计决策的沟通能力。再此之上，掌握作为设计师最核心价值的思维和逻辑，能快速发现痛点并快速定义问题，准确提出具有商业价值和技术可行的设计解决方案。也会让你脱离执行层真正成为一名用户体验设计师。</p>
                </div>

              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path4-step1.jpg" alt="UIUX">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path4-step1-mb.jpg" alt="UIUX">
                <a href="https://mp.weixin.qq.com/s/SbZbB7UrMrFLFX2zf-aSOA" target="_blank">学员作品→</a>
                <a href="https://www.dinlab.cn/course/621" target="_blank">更多了解课程→</a>
              </div>
              <div class="step__item">
                <img class="pc" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path4-step2.jpg" alt="AIGC商业全流程">
                <img class="mb" src="https://assets.dinlab.cn/staticPage/learningpath/202111/path4-step2-mb.jpg" alt="AIGC商业全流程">
                <!-- <a href="https://mp.weixin.qq.com/s/SbZbB7UrMrFLFX2zf-aSOA" target="_blank">学员作品→</a> -->
                <a href="https://www.dinlab.cn/course/634" target="_blank">更多了解课程→</a>
              </div>
            </div>
            <div class="coursebag">
              <div class="coursebag__title">
                <h4>竞争突围补给包</h4>
                <h6>共 2 门课程</h6>
                <p>UXUI设计师的终极目的是设计出兼顾商业价值与用户体验的产品，运用新结合C4D、Motion Graphic Design、等三维渲染、动态图形以及编程设计的新技术、新媒介，会使你革新视觉呈现并且事半功倍，也会让你的创作更具商业价值与创新创意。</p>
              </div>
              <div class="coursebag__item">
                <img src="https://assets.dinlab.cn/staticPage/learningpath/202111/path4-course1.jpg" alt="AE动效设计">
                <!-- <a href="https://shimo.im/docs/1d3aVWd0aKUxGJqg/" target="_blank">学员作品→</a> -->
                <a href="https://www.dinlab.cn/course/535" target="_blank">更多了解课程→</a>
              </div>
            </div>
            <div class="buybuybuy">
              <h2>跟随路径学习 加速企业直推</h2>
              <h4>单独学习购买任何一项查漏补缺。</h4>
              <h5>也可 <a class="pathBuy4">购买</a> 完整路径，最高优惠<span> 500元！</span></h5>
              <img src="https://video.dinlab.cn/images/learningpath/path4-boy.png" alt="">
            </div>
          </div>
        </div>
      </div><!-- /page -->
    </main>
    <div class="path-popup">
      <div class="popupwindow">
        <button class="popup-close">✕</button>
        <img src="https://assets.dinlab.cn/staticPage/learningpath/path-popup.png" alt="path-buy">
      </div>
    </div>
    <TheFooter class="TheFooter"></TheFooter>
  </div>
</template>

<script>
  import { TweenMaxFunction } from "../utils/TweenMax";
  import { TITLE_SUFFIX } from "../constant/constant";
  import TheFooter from "../components/TheFooter";

  export default {
    name: "LearningPath",
    components: {
      TheFooter,
    },
    data() {
      return {
        timer: false,
        home: "/home",
        path: this.$route.query.path,
        isMobile: false,
      };
    },
    created() {
      document.title = "职业路径" + TITLE_SUFFIX;
    },
    mounted() {
      this.onCreateView();
    },
    methods: {
      onCreateView() {
        // document.querySelector('body').classList.add('posr');
        // slidesFunction();
        // window.scrollTo(0, 1);
        document.documentElement.className = "js";
        var supportsCssVars = function () {
          var e,
            t = document.createElement("style");
          return (
            (t.innerHTML = "root: { --tmp-var: bold; }"),
            document.head.appendChild(t),
            (e = !!(
              window.CSS &&
              window.CSS.supports &&
              window.CSS.supports("font-weight", "var(--tmp-var)")
            )),
            t.parentNode.removeChild(t),
            e
          );
        };
        supportsCssVars() ||
          alert("Please view this demo in a modern browser that supports CSS Variables.");
        TweenMaxFunction();

        {
          // https://pawelgrzybek.com/page-scroll-in-vanilla-javascript/
          function scrollIt(destination, duration = 200, easing = "linear", callback) {
            const easings = {
              linear(t) {
                return t;
              },
              easeInQuad(t) {
                return t * t;
              },
              easeOutQuad(t) {
                return t * (2 - t);
              },
              easeInOutQuad(t) {
                return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
              },
              easeInCubic(t) {
                return t * t * t;
              },
              easeOutCubic(t) {
                return --t * t * t + 1;
              },
              easeInOutCubic(t) {
                return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
              },
              easeInQuart(t) {
                return t * t * t * t;
              },
              easeOutQuart(t) {
                return 1 - --t * t * t * t;
              },
              easeInOutQuart(t) {
                return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
              },
              easeInQuint(t) {
                return t * t * t * t * t;
              },
              easeOutQuint(t) {
                return 1 + --t * t * t * t * t;
              },
              easeInOutQuint(t) {
                return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
              },
            };

            const start = window.pageYOffset;
            const startTime = "now" in window.performance ? performance.now() : new Date().getTime();

            const documentHeight = Math.max(
              document.body.scrollHeight,
              document.body.offsetHeight,
              document.documentElement.clientHeight,
              document.documentElement.scrollHeight,
              document.documentElement.offsetHeight
            );
            const windowHeight =
              window.innerHeight ||
              document.documentElement.clientHeight ||
              document.getElementsByTagName("body")[0].clientHeight;
            const destinationOffset =
              typeof destination === "number" ? destination : destination.offsetTop;
            const destinationOffsetToScroll = Math.round(
              documentHeight - destinationOffset < windowHeight
                ? documentHeight - windowHeight
                : destinationOffset
            );

            if ("requestAnimationFrame" in window === false) {
              window.scroll(0, destinationOffsetToScroll);
              if (callback) {
                callback();
              }
              return;
            }

            function scroll() {
              const now = "now" in window.performance ? performance.now() : new Date().getTime();
              const time = Math.min(1, (now - startTime) / duration);
              const timeFunction = easings[easing](time);
              window.scroll(
                0,
                Math.abs(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start))
              );
              if (window.pageYOffset === destinationOffsetToScroll) {
                if (callback) {
                  callback();
                }
                return;
              }

              requestAnimationFrame(scroll);
            }

            scroll();
          }

          // Generates a random float.
          const getRandom = (min, max) => (Math.random() * (max - min) + min).toFixed(2);

          // from http://www.quirksmode.org/js/events_properties.html#position
          const getMousePos = (e) => {
            let posx = 0;
            let posy = 0;
            if (!e) e = window.event;
            if (e.pageX || e.pageY) {
              posx = e.pageX;
              posy = e.pageY;
            } else if (e.clientX || e.clientY) {
              posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
              posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
            }
            return { x: posx, y: posy };
          };

          // Equation of a line (y = mx + b ).
          const lineEq = (y2, y1, x2, x1, currentVal) => {
            const m = (y2 - y1) / (x2 - x1);
            const b = y1 - m * x1;
            return m * currentVal + b;
          };

          // Window sizes.
          let winsize;
          const calcWinsize = () =>
            (winsize = { width: window.innerWidth, height: window.innerHeight });
          calcWinsize();
          window.addEventListener("resize", calcWinsize);

          let allowTilt = true;
          const path = this.path;
          const router = this.$router;

          class Grid {
            constructor(el) {
              this.DOM = { el: el };
              // Some configuration values.
              this.config = {
                // The min and max values to move each item (y-axis) when we move the mouse.
                titltOffset: { min: 5, max: 40 },
              };
              // Grid items.
              this.DOM.items = Array.from(this.DOM.el.querySelectorAll(".grid__item"));
              // Total items.
              this.itemsTotal = this.DOM.items.length;
              // Spread the grid items.
              this.spread();
              //window.addEventListener('resize', () => this.spread());
            }
            spread() {
              // Randomly spread the grid items.
              this.DOM.items.forEach((item) => {
                // The min and max values to move each item (y-axis) when we move the mouse.
                const randnum = getRandom(this.config.titltOffset.min, this.config.titltOffset.max);
                item.dataset.minTy = -1 * randnum;
                item.dataset.maxTy = randnum;

                const rect = item.getBoundingClientRect();
                // Item´s center point.
                const center = {
                  x: rect.left + rect.width / 2,
                  y: rect.top + rect.height / 2,
                };
                // Calculate the item´s quadrant in the viewport.
                const quadrant =
                  center.x >= winsize.width / 2
                    ? center.y <= winsize.height / 2
                      ? 1
                      : 4
                    : center.y <= winsize.height / 2
                    ? 2
                    : 3;

                // Now calculate how much to translate the item.
                // The positions will be random but only in the area of the item´s quadrant.
                // Also, consider a margin so the item does not stay completely out of the viewport or its quadrant.
                const margins = {
                  x: winsize.width * 0.05,
                  y: winsize.height * 0.05,
                };
                const tx =
                  quadrant === 1 || quadrant === 4
                    ? getRandom(
                        -1 * center.x + winsize.width / 2 + margins.x,
                        winsize.width - center.x - margins.x
                      )
                    : getRandom(-1 * center.x + margins.x, winsize.width / 2 - center.x - margins.x);
                const ty =
                  quadrant === 1 || quadrant === 2
                    ? getRandom(-1 * center.y + margins.y, winsize.height / 2 - center.y - margins.y)
                    : getRandom(
                        -1 * center.y + winsize.height / 2 + margins.y,
                        winsize.height - center.y - margins.y
                      );

                // Save the current translation.
                item.dataset.ctx = tx;
                item.dataset.cty = ty;

                TweenMax.set(item, {
                  x: tx,
                  y: ty,
                  scale: 0.5,
                });
              });
            }
            tilt(ev) {
              if (!allowTilt) return;
              const mousepos = getMousePos(ev);
              // Document scrolls.
              const docScrolls = {
                left: document.body.scrollLeft + document.documentElement.scrollLeft,
                top: document.body.scrollTop + document.documentElement.scrollTop,
              };
              // Mouse position relative to the main element.
              const relmousepos = {
                x: mousepos.x - docScrolls.left,
                y: mousepos.y - docScrolls.top,
              };
              // Movement settings for the tilt elements.
              this.DOM.items.forEach((item) => {
                TweenMax.to(item, 4, {
                  ease: Quint.easeOut,
                  y:
                    Number(item.dataset.cty) +
                    lineEq(item.dataset.maxTy, item.dataset.minTy, winsize.height, 0, relmousepos.y),
                });
              });
            }
            hideItems(direction) {
              return this.toggleItems("hide", direction);
            }
            showItems(direction) {
              return this.toggleItems("show", direction);
            }
            toggleItems(action, direction) {
              return new Promise((resolve, reject) => {
                let cnt = 0;
                this.DOM.items.forEach((item) => {
                  const rect = item.getBoundingClientRect();

                  // The speed and delay will depend on how much the item can be translated when moving the mouse (this.config.titltOffset).
                  // This will result in some items moving faster than others and also starting at different times.
                  const speed = lineEq(
                    1.3,
                    0.9,
                    this.config.titltOffset.min,
                    this.config.titltOffset.max,
                    item.dataset.maxTy
                  );
                  const delay = lineEq(
                    0,
                    0.4,
                    this.config.titltOffset.min,
                    this.config.titltOffset.max,
                    item.dataset.maxTy
                  );

                  TweenMax.to(item, speed, {
                    ease: Expo.easeInOut,
                    delay: delay,
                    startAt:
                      action === "show"
                        ? {
                            y:
                              direction === "up"
                                ? `+=${winsize.height + rect.height}`
                                : `-=${winsize.height + rect.height}`,
                            opacity: 1,
                          }
                        : null,
                    y:
                      action === "show"
                        ? item.dataset.cty
                        : direction === "up"
                        ? `-=${winsize.height + rect.height}`
                        : `+=${winsize.height + rect.height}`,
                  });

                  TweenMax.to(item, action === "show" ? speed * 0.55 : speed * 0.45, {
                    ease: action === "show" ? Quad.easeIn : Expo.easeIn,
                    delay: delay,
                    scaleX: 0.45,
                    scaleY: getRandom(1, 1.3),
                    opacity: 0.5,
                    onComplete: () => {
                      TweenMax.to(item, action === "show" ? speed * 0.45 : speed * 0.55, {
                        ease: action === "show" ? Expo.easeOut : Quad.easeOut,
                        scaleX: 0.5,
                        scaleY: 0.5,
                        opacity: 1,
                        onComplete: () => {
                          if (action === "hide") {
                            TweenMax.set(item, {
                              opacity: 0,
                              y: item.dataset.cty,
                            });
                          }
                          cnt++;
                          if (this.itemsTotal === cnt) {
                            resolve();
                          }

                          /*
                                                                          // If we want to shuffle the items again after the navigation:
                                                                          if ( action === 'hide' ) {
                                                                              TweenMax.set(item, {opacity: 0, y: 0});
                                                                          }
                                                                          cnt++;
                                                                          if ( this.itemsTotal === cnt ) {
                                                                              if ( action === 'hide' ) {
                                                                                  this.spread();
                                                                              }
                                                                              resolve();
                                                                          }
                                                                          */
                        },
                      });
                    },
                  });
                });
              });
            }
            open() {
              return new Promise((resolve, reject) => {
                this.DOM.el.classList.add("grid--open");

                TweenMax.to(this.DOM.items, 1, {
                  ease: Expo.easeInOut,
                  x: 0,
                  y: 0,
                  scale: 1,
                  onComplete: resolve,
                });
              });
            }
            close() {
              return new Promise((resolve, reject) => {
                this.DOM.el.classList.remove("grid--open");

                this.DOM.items.forEach((item) => {
                  TweenMax.to(item, 1, {
                    ease: Expo.easeInOut,
                    x: item.dataset.ctx,
                    y: item.dataset.cty,
                    scale: 0.5,
                    onComplete: resolve,
                  });
                });
              });
            }
          }

          class MenuItem {
            constructor(el) {
              this.DOM = { el: el };
              this.DOM.number = this.DOM.el.querySelector(".menu__item-number");
              this.DOM.textwrap = this.DOM.el.querySelector(".menu__item-textwrap");
              this.DOM.text = this.DOM.textwrap.querySelector(".menu__item-text");
              this.DOM.textzh = this.DOM.textwrap.querySelector(".menu__item-text-ZH");
              this.DOM.link = this.DOM.el.querySelector(".menu__item-link");
              this.DOM.linkdisable = this.DOM.el.querySelector(".menu__item-diaable");
            }
            toggleCurrent(direction = "up") {
              const isCurrent = this.DOM.el.classList.contains("menu__item--current");
              this.DOM.el.classList[isCurrent ? "remove" : "add"]("menu__item--current");
              // Toggle the link element ("explore").
              // TweenMax.to(this.DOM.link, 1, {
              //   startAt: isCurrent ? null : { opacity: 0, y: direction === 'up' ? 15 : -15 },
              //   y: isCurrent ? direction === 'up' ? -15 : 15 : 0,
              //   opacity: isCurrent ? 0 : 1
              // });
            }
            show() {
              this.toggle("show");
            }
            hide() {
              this.toggle("hide");
            }
            toggle(action) {
              // Slide in/out the text.
              TweenMax.to(this.DOM.text, action === "hide" ? 0.5 : 1, {
                ease: action === "hide" ? Expo.easeIn : Expo.easeInOut,
                startAt: action === "hide" ? null : { y: "103%" },
                y: action === "hide" ? "103%" : "0%",
              });
              TweenMax.to(this.DOM.textzh, action === "hide" ? 0.5 : 1, {
                ease: action === "hide" ? Expo.easeIn : Expo.easeInOut,
                startAt: action === "hide" ? null : { y: "-210%" },
                y: action === "hide" ? "-210%" : "0%",
              });

              // Fade in/out the number and link.
              let extraElems = [this.DOM.link];
              if (action === "show" && !this.DOM.el.classList.contains("menu__item--current")) {
                extraElems = [];
              }
              // Fade in/out the number and link.
              let extraHeaderElems = [this.DOM.linkheader];
              if (action === "show" && !this.DOM.el.classList.contains("headerNav__item--current")) {
                extraHeaderElems = [];
              }
              // TweenMax.to(extraElems, action === 'hide' ? 0.5 : 1, {
              //   ease: action === 'hide' ? Quint.easeIn : Quint.easeInOut,
              //   startAt: action === 'hide' ? null : { opacity: 0 },
              //   opacity: action === 'hide' ? 0 : 1
              // });
            }
          }

          class ContentItem {
            constructor(el) {
              this.DOM = { el: el };
            }
            toggleCurrent() {
              this.DOM.el.classList[
                this.DOM.el.classList.contains("content__item--current") ? "remove" : "add"
              ]("content__item--current");
            }
          }

          class HeaderNavItem {
            constructor(el) {
              this.DOM = { el: el };
            }
            toggleCurrent() {
              this.DOM.el.classList[
                this.DOM.el.classList.contains("headerNav__item--current") ? "remove" : "add"
              ]("headerNav__item--current");
            }
          }

          class NavController {
            constructor(el) {
              this.DOM = { menu: el }; // Initialize with the menu element.
              // The Menu items instances.
              this.menuItems = [];
              Array.from(this.DOM.menu.querySelectorAll(".menu__item")).forEach((item) =>
                this.menuItems.push(new MenuItem(item))
              );
              // The page element (the grids and contents parent)
              this.DOM.page = document.querySelector(".page");
              this.DOM.mainPage = document.querySelector(".page-path");
              this.DOM.windowPage = document.querySelector(".main-path");
              // The grid´s wrap.
              this.DOM.gridWrap = this.DOM.page.querySelector(".gridwrap");
              // The back ctrl. For closing the grid/content view and go back to the main page.
              this.DOM.backCtrl = this.DOM.mainPage.querySelector(".gridback");
              this.DOM.headerNav = this.DOM.mainPage.querySelector(".path-header");
              this.DOM.TheFooter = this.DOM.mainPage.querySelector(".TheFooter");

              // The content items instances.
              this.contentItems = [];
              Array.from(this.DOM.page.querySelectorAll(".content > .content__item")).forEach(
                (item) => this.contentItems.push(new ContentItem(item))
              );
              // The headerNav items instances.
              this.headerNavItems = [];
              Array.from(this.DOM.headerNav.querySelectorAll(".headerNav__item")).forEach((item) =>
                this.headerNavItems.push(new HeaderNavItem(item))
              );
              // The grid instances.
              this.grids = [];
              Array.from(this.DOM.gridWrap.querySelectorAll(".grid")).forEach((grid) =>
                this.grids.push(new Grid(grid))
              );
              this.init();
            }
            init() {
              // Current nav menu item index (starting with the first one).
              this.current = 0;
              // Add current class to the first menu item.
              this.menuItems[this.current].toggleCurrent();

              // this.headerMenuItems[this.current].toggleCurrent();
              // Also show the current grid items.
              this.grids[this.current].DOM.items.forEach((item) =>
                TweenMax.set(item, { opacity: 1 })
              );
              // Add current class to the first content item.
              this.contentItems[this.current].toggleCurrent();
              this.headerNavItems[this.current].toggleCurrent();
              this.initEvents();
              if (path) {
                this.toggleContent(path);
              }
            }
            initEvents() {
              // Move the current grid´s items on the y-axis as the user moves the mouse.
              this.mousemoveFn = (ev) =>
                requestAnimationFrame(() => this.grids[this.current].tilt(ev));
              window.addEventListener("mousemove", this.mousemoveFn);

              // Clicking the menu item text and link. (navigation and show the grid/content).
              for (const [pos, item] of this.menuItems.entries()) {
                // Clicking on the menu item text will trigger the navigation: the current grid items move away and the new ones come in.
                item.DOM.textwrap.addEventListener("click", () => {
                  this.navigate(pos);
                  this.showContent(pos);
                  router.push({ path: "learningpath", query: { path: pos } });
                });
                // Clicking the view all will show the grid.
                item.DOM.link.addEventListener("click", () => {
                  this.showContent(pos);
                  router.push({ path: "learningpath", query: { path: pos } });
                });
              }
              for (const [pos, item] of this.headerNavItems.entries()) {
                // Clicking the view all will show the grid.
                // item.DOM.linkheader.addEventListener('click', () => this.showContent(pos));
                item.DOM.el.addEventListener("click", () => {
                  // this.hideContent();
                  // this.navigate(pos);
                  // this.showContent(pos);
                  this.toggleContent(pos);
                });
              }

              // Closing the grid/content view.
              this.DOM.backCtrl.addEventListener("click", () => this.hideContent());
              // this.DOM.headerNav.addEventListener('click', () => this.hideContent());
              // this.DOM.pathBuy = this.DOM.mainPage.querySelectorAll('.pathBuy');
              this.DOM.pathBuy1 = this.DOM.mainPage.querySelector(".pathBuy1");
              this.DOM.pathBuy2 = this.DOM.mainPage.querySelector(".pathBuy2");
              this.DOM.pathBuy3 = this.DOM.mainPage.querySelector(".pathBuy3");
              this.DOM.pathBuy4 = this.DOM.mainPage.querySelector(".pathBuy4");
              this.DOM.pathPopup = this.DOM.mainPage.querySelector(".path-popup");
              this.DOM.popupClose = this.DOM.mainPage.querySelector(".popup-close");
              this.DOM.pathBuy1.addEventListener("click", () => this.pathBuyOpen());
              this.DOM.pathBuy2.addEventListener("click", () => this.pathBuyOpen());
              this.DOM.pathBuy3.addEventListener("click", () => this.pathBuyOpen());
              this.DOM.pathBuy4.addEventListener("click", () => this.pathBuyOpen());
              this.DOM.popupClose.addEventListener("click", () => this.pathBuyClose());
            }
            navigate(pos) {
              if (this.isAnimating || pos === this.current) return;
              const direction = this.current < pos ? "up" : "down";
              this.menuItems[this.current].toggleCurrent(direction);
              this.contentItems[this.current].toggleCurrent();
              this.headerNavItems[this.current].toggleCurrent();
              this.isAnimating = true;
              // Disable the mousemove functionality.
              allowTilt = false;
              // Hide the current grid items.
              this.grids[this.current].hideItems(direction);
              // Update current value.
              this.current = pos;
              this.menuItems[this.current].toggleCurrent(direction);
              this.contentItems[this.current].toggleCurrent();
              this.headerNavItems[this.current].toggleCurrent();
              // Show the next grid items.
              this.grids[this.current].showItems(direction).then(() => {
                this.isAnimating = false;
                allowTilt = true;
              });
            }
            showContent(pos) {
              if (
                this.isAnimating ||
                this.grids[this.current].DOM.el.classList.contains("grid--open")
              )
                return;
              this.isAnimating = true;
              // Disable the mousemove functionality.
              allowTilt = false;
              // Disable the menu.
              this.DOM.menu.classList.add("menu--closed");
              this.DOM.backCtrl.classList.add("show");
              this.DOM.headerNav.classList.add("show");
              this.DOM.TheFooter.classList.add("show");
              this.DOM.windowPage.classList.add("show");
              // Show the grid.
              this.grids[this.current].open().then(() => (this.isAnimating = false));
              // Hide the menu items.
              for (const item of this.menuItems) {
                item.hide();
              }
              // Allow scroll.
              this.DOM.page.classList.remove("page--preview");
              // Show back ctrl.
              // TweenMax.to(this.DOM.backCtrl, 1, {
              //   ease: Expo.easeInOut,
              //   opacity: 1
              // });
              // TweenMax.to(this.DOM.headerNav, 1, {
              //   ease: Expo.easeInOut,
              //   opacity: 1
              // });
            }
            toggleContent(pos) {
              router.push({ path: "learningpath", query: { path: pos } });
              if (this.isAnimating || pos === this.current) return;
              const direction = this.current < pos ? "up" : "down";
              this.menuItems[this.current].toggleCurrent(direction);
              this.contentItems[this.current].toggleCurrent();
              this.headerNavItems[this.current].toggleCurrent();
              this.isAnimating = true;
              // Disable the mousemove functionality.
              allowTilt = false;
              // Hide the current grid items.
              this.grids[this.current].hideItems(direction);
              // Update current value.
              this.current = pos;
              this.menuItems[this.current].toggleCurrent(direction);
              this.contentItems[this.current].toggleCurrent();
              this.headerNavItems[this.current].toggleCurrent();
              // Show the next grid items.
              this.grids[this.current].showItems(direction).then(() => {
                return new Promise((resolve, reject) => {
                  this.grids[this.current].DOM.el.classList.add("grid--open");
                  // this.isAnimating = true;
                  TweenMax.to(this.grids[this.current].DOM.items, 1, {
                    ease: Expo.easeInOut,
                    x: 0,
                    y: 0,
                    scale: 1,
                    onComplete: resolve,
                  });
                  // this.isAnimating = false;
                });
              });

              this.isAnimating = true;
              // Disable the mousemove functionality.
              allowTilt = false;
              // Disable the menu.
              this.DOM.menu.classList.add("menu--closed");
              this.DOM.backCtrl.classList.add("show");
              this.DOM.headerNav.classList.add("show");
              this.DOM.TheFooter.classList.add("show");
              this.DOM.windowPage.classList.add("show");
              this.grids[0].close();
              this.grids[1].close();
              this.grids[2].close();
              this.grids[3].close();
              this.isAnimating = false;
              for (const item of this.menuItems) {
                item.hide();
              }
              // Allow scroll.
              this.DOM.page.classList.remove("page--preview");
            }
            pathBuyOpen() {
              this.DOM.pathPopup.classList.add("show");
            }
            pathBuyClose() {
              this.DOM.pathPopup.classList.remove("show");
            }
            hideContent() {
              router.push({ path: "learningpath" });
              if (
                this.isAnimating ||
                !this.grids[this.current].DOM.el.classList.contains("grid--open")
              )
                return;
              this.isAnimating = true;
              this.DOM.backCtrl.classList.remove("show");
              this.DOM.headerNav.classList.remove("show");
              this.DOM.TheFooter.classList.remove("show");
              this.DOM.windowPage.classList.remove("show");

              // Hide back ctrl.
              // TweenMax.to(this.DOM.backCtrl, 1, {
              //   ease: Expo.easeInOut,
              //   opacity: 0
              // });
              // TweenMax.to(this.DOM.headerNav, 1, {
              //   ease: Expo.easeInOut,
              //   opacity: 0
              // });

              scrollIt(0, 300, "easeOutQuad", () => {
                // Disabel scroll.
                this.DOM.page.classList.add("page--preview");
                // Hide the grid.
                this.grids[this.current].close().then(() => {
                  // Enable the menu.
                  this.DOM.menu.classList.remove("menu--closed");
                  // Enable the mousemove functionality.
                  allowTilt = true;
                  this.isAnimating = false;
                });
                // Show the menu items.
                for (const item of this.menuItems) {
                  item.show();
                }
              });
            }
          }

          // Initialize the nav controller.
          const controller = new NavController(document.querySelector(".menu"));
        }
      },
    },
  };
</script>

<style lang="scss">
  @font-face {
    font-family: "SourceHanSansCN-Heavy";
    src: url("https://video.dinlab.cn/fonts/SourceHanSansCN-Heavy.woff2") format("woff2"),
      url("https://video.dinlab.cn/fonts/SourceHanSansCN-Heavy.woff") format("woff"),
      url("https://video.dinlab.cn/fonts/SourceHanSansCN-Heavy.ttf") format("truetype"),
      url("https://video.dinlab.cn/fonts/SourceHanSansCN-Heavy.eot") format("embedded-opentype"),
      url("https://video.dinlab.cn/fonts/SourceHanSansCN-Heavy.svg") format("svg");
  }
  .disable {
    pointer-events: none !important;
  }
  .TheFooter {
    display: none;
  }
  .TheFooter.show {
    display: block;
  }
  .page-path {
    background: #ffffff;
    main.main-path {
      position: relative;
      width: 100%;
      .path-header {
        width: 100%;
        height: 70px;
        padding: 0 calc((100vw - 1410px) / 2);
        position: fixed;
        z-index: 999;
        top: 0px;
        background: #f5f5f5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        opacity: 0;
        transition: all 0.2s;
        &.show {
          opacity: 1;
        }
        .left {
          display: flex;
          justify-content: space-between;
          align-items: center;
          h2 {
            font-size: 2.6rem;
            font-weight: 300;
            margin-right: 20px;
          }
          .gridback {
            font-size: 16px;
            line-height: 16px;
            color: #99a0b2;
            letter-spacing: 1px;
            border: 0;
            border-radius: 8px;
            background: #ffffff;
            padding: 8px 12px 8px;
            vertical-align: middle;
            cursor: pointer;
            opacity: 0;
            transition: all 0.1s;
            display: flex;
            justify-content: center;
            align-items: center;
            svg {
              fill: #99a0b2;
              margin-right: 4px;
            }
            &:hover {
              background: rgba(0, 0, 0, 0.05);
              color: #42454d;
              svg {
                fill: #42454d;
              }
            }
          }
          .gridback.show {
            opacity: 1;
          }
        }
        .headerNav {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .headerNav__item {
            display: block;
            line-height: 52px;
            border-radius: 52px;
            border: 0;
            padding: 0 25px;
            font-size: 16px;
            color: #99a0b2;
            letter-spacing: 1px;
            text-align: center;
            border-left: 1px solid transparent;
            border-right: 1px solid transparent;
            background: rgba(0, 0, 0, 0);
            transition: all 0.2s;
            cursor: pointer;
          }
          .headerNav__item.headerNav__item--current {
            background: #ffffff;
            color: #42454d;
            font-weight: 800;
          }
        }
      }
    }

    .path-popup {
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.75);
      z-index: -1;
      opacity: 0;
      transition: all 0.2s;
      .popupwindow {
        width: 40vw;
        max-width: 500px;
        position: relative;
        img {
          width: 100%;
        }
        .popup-close {
          position: absolute;
          right: 15px;
          top: 15px;
          border: 0;
          font-size: 20px;
          line-height: 16px;
          font-weight: 200;
          padding: 8px;
          color: rgba(0, 0, 0, 0.3);
          background: #f5f5f5;
          border-radius: 12px;
          cursor: pointer;
        }
      }

      &.show {
        opacity: 1;
        z-index: 99999;
      }
    }

    .frame {
      padding: 2rem 1rem 0;
      text-align: center;
      position: absolute;
      z-index: 10000;
      top: 0;
      left: 0;
      width: 100%;
    }

    /* Header */
    .codrops-header {
      position: relative;
      z-index: 100;
    }

    .codrops-header__links a {
      display: inline-block;
      text-transform: lowercase;
    }

    .codrops-header__links a:nth-child(2) {
      margin: 0 0.5rem;
    }

    .codrops-header__title {
      font-size: 1rem;
      line-height: 1;
      margin: 0 0 0.75rem 0;
    }

    .pageheader {
      font-size: 1rem;
      margin: 1rem 0;
    }

    .menutop__item {
      pointer-events: auto;
      font-weight: bold;
      cursor: pointer;
      margin: 0 0.5rem;
    }

    .menutop__item--social {
      color: #323232;
    }

    .menu {
      position: fixed;
      top: 9.6875rem;
      left: 0;
      width: 100%;
      height: calc(100% - 9.6875rem);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      pointer-events: none;
      top: 0;
      height: 100%;
    }

    .menu__item {
      position: relative;
      width: 100vw;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      pointer-events: auto;
      margin: 1rem 0;
    }

    .menu--closed .menu__item {
      pointer-events: none;
    }

    .menu--closed .menu__item--current .menu__item-link {
      opacity: 0;
    }

    .menu__item-textwrap {
      position: relative;
      overflow: hidden;
      width: 100vw;
      height: 100px;
      line-height: 1;
      margin: 0;
      .menu__item-text {
        position: absolute;
        top: 0;
        height: 100px;
        font-family: "cobe-heavy";
        font-size: 7rem;
        line-height: 7rem;
        z-index: 2;
        opacity: 1;
        .menu__item-text-outline {
          position: absolute;
          top: 0;
          -webkit-text-stroke: 1px #f2f3f5;
          -webkit-text-fill-color: transparent;
          display: inline-block;
          width: 100vw;
          text-align: center;
        }
        .loop-holder {
          display: flex;
          white-space: nowrap;
          overflow: hidden;
          opacity: 0;
          .loop-holder__text {
            animation: textLoop 20s linear infinite;
            font-size: 6vw;
            padding-right: 0.35em;
            color: #f2f3f5;
          }
          @keyframes textLoop {
            0% {
              -webkit-transform: translate3d(0, 0, 0);
              transform: translate3d(0, 0, 0);
            }
            100% {
              -webkit-transform: translate3d(-100%, 0, 0);
              transform: translate3d(-100%, 0, 0);
            }
          }
        }
      }
      .menu__item-text-ZH {
        width: 50vw;
        margin: 0 auto;
        position: absolute;
        top: 0;
        left: 25vw;
        z-index: 3;
        height: 100px;
        .text {
          width: 50vw;
          position: absolute;
          top: 0;
          left: 0;
          text-align: center;
          font-family: SourceHanSansCN-Heavy;
          -webkit-text-stroke: 1px #42454d;
          -webkit-text-fill-color: #fff;
          font-size: 3.6rem;
          line-height: 7rem;
          z-index: 3;
          transition: 0.3s all;
        }
        .menu__item-number {
          display: inline-block;
          opacity: 0;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 25px;
          left: 50px;
          transition: opacity 0.15s;
          background-image: url(https://video.dinlab.cn/images/learningpath/path-eye.png);
          background-size: cover;
          transition: all 0.15s 0.1s;
        }
        .menu__item-link {
          position: absolute;
          right: 0;
          top: 32px;
          background: #ff6f61;
          color: #fff !important;
          font-size: 1.2rem;
          font-weight: bold;
          line-height: 1;
          padding: 10px 16px 10px;
          border-radius: 8px;
          opacity: 0;
          width: auto;
          cursor: pointer;
          text-align: center;
          transform: translateX(-20px);
          transition: all 0.3s ease 0s;
          // &::after {
          //   content: "";
          //   position: absolute;
          //   top: 0;
          //   right: -19px;
          //   border-left: solid 19px #ff6f61;
          //   border-bottom: solid 19px transparent;
          //   border-top: solid 19px transparent;
          // }
        }
      }
      &:hover {
        cursor: pointer;
        .menu__item-text-ZH {
          .menu__item-number {
            opacity: 0.1;
          }
          .text {
            -webkit-text-stroke: 0;
            -webkit-text-fill-color: #838999;
          }
        }
      }
    }
    .menu__item--current {
      .menu__item-text {
        .menu__item-text-outline {
          opacity: 0;
        }
        .loop-holder {
          opacity: 1;
        }
      }
      .menu__item-text-ZH {
        .menu__item-number {
          opacity: 1;
        }
        .text {
          -webkit-text-stroke: 0;
          -webkit-text-fill-color: #004bff;
        }
        .menu__item-link {
          opacity: 1;
          transform: translateX(0px);
        }
      }
      &:hover {
        cursor: pointer;
        .menu__item-text-ZH {
          .menu__item-number {
            opacity: 1;
          }
          .text {
            -webkit-text-stroke: 0;
            -webkit-text-fill-color: #004bff;
          }
        }
      }
    }

    .gridwrap {
      display: grid;
      max-width: 1440px;
      margin: 0 auto;
      padding-top: 0px;
      grid-template-columns: 100%;
      grid-template-rows: 1.75rem calc(100% - 1.75rem);
      place-items: center;
      position: relative;
      pointer-events: none;
    }

    .grid--open ~ .gridback {
      pointer-events: auto;
    }

    // .page--preview .gridwrap {
    //   .grid {
    //     grid-area: 2 / 1 / 3 / 2;
    //     --gridgap: 30px;
    //     --gridwidth: 100%;
    //     --gridheight: 100vh !important;
    //     display: grid;
    //     width: var(--gridwidth);
    //     height: var(--gridheight);
    //     grid-template-rows: repeat(
    //       8,
    //       calc(var(--gridheight) / 8 - var(--gridgap))
    //     );
    //     grid-template-columns: repeat(12, 90px);
    //     grid-gap: var(--gridgap);
    //     align-content: start;
    //     justify-content: center;
    //     margin-top: 0;
    //   }
    // }

    .grid {
      grid-area: 2 / 1 / 3 / 2;
      --gridgap: 30px;
      --gridwidth: 100%;
      --gridheight: 900px;
      display: grid;
      width: var(--gridwidth);
      height: var(--gridheight);
      grid-template-rows: repeat(9, calc(var(--gridheight) / 9 - var(--gridgap)));
      grid-template-columns: repeat(12, 90px);
      grid-gap: var(--gridgap);
      align-content: start;
      justify-content: center;
      margin-top: 0;
    }

    .grid__item {
      opacity: 0;
      position: relative;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: cover;
      margin-top: 20px;
      margin-bottom: 20px;
      p {
        font-weight: 300;
        font-size: 20px;
        color: #42454d;
        letter-spacing: 1px;
        position: absolute;
        bottom: -44px;
        opacity: 0;
        transform: translateY(20px);
        transition: all 0.2s ease 0.4s;
      }
    }

    .grid--open .grid__item {
      pointer-events: auto;
      border-radius: 20px;
    }

    .grid__item::after {
      content: "";
      background: rgba(255, 255, 255, 0.8);
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      transition: background 1s cubic-bezier(1, 0, 0, 1);
    }

    .grid {
      .grid__title {
        opacity: 0;
        transform: translateY(20px);
        transition: all 0.2s ease 0.4s;
        grid-area: 2 / 1 / 7 / 7;
        position: relative;
        h2 {
          font-family: SourceHanSansCN-Heavy;
          font-size: 60px;
          color: #004bff;
          letter-spacing: 1.76px;
          line-height: 1;
          span {
            color: #42454d;
          }
        }
        h3 {
          margin-top: 5px;
          margin-bottom: 30px;
          color: #f2f3f5;
          font-family: "cobe-heavy";
          font-size: 60px;
          line-height: 1;
          letter-spacing: 0;
        }
        .path-icon {
          width: 60px;
          height: 60px;
          align-self: center;
          background-size: cover;
          position: absolute;
          top: 0px;
          right: 0px;
          transition: all 0.15s 0.1s;
        }
        p {
          font-weight: 300;
          font-size: 1.6rem;
          color: #42454d;
          letter-spacing: 1px;
          text-align: justify;
          line-height: 2;
          padding-right: 100px;
        }
      }
      .grid__item:nth-child(2) {
        grid-area: 2 / 7 / 7 / 13;
        margin-top: 0px;
        margin-bottom: 0px;
        border-radius: 20px;
      }
      .grid__item:nth-child(3) {
        grid-area: 7 / 1 / 9 / 3;
        border-radius: 20px;
      }
      .grid__item:nth-child(4) {
        grid-area: 7 / 3 / 9 / 5;
        border-radius: 20px;
      }
      .grid__item:nth-child(5) {
        grid-area: 7 / 5 / 9 / 7;
        border-radius: 20px;
      }
      .grid__item:nth-child(6) {
        grid-area: 7 / 7 / 9 / 9;
        border-radius: 20px;
      }
      .grid__item:nth-child(7) {
        grid-area: 7 / 9 / 9 / 11;
        border-radius: 20px;
      }
      .grid__item:nth-child(8) {
        grid-area: 7 / 11 / 9 / 13;
        border-radius: 20px;
      }
    }

    .grid--open {
      .grid__item p {
        opacity: 1;
        transform: translateY(0);
      }
      .grid__item::after {
        background: rgba(0, 0, 0, 0);
      }
      .grid__title {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .content {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      min-height: 60vh;
      padding-top: 0px;
      overflow: visible;
      .content__item {
        .jd {
          width: 100%;
          margin-bottom: 60px;
          max-width: 1440px;
          margin-bottom: 140px;
          .grid__jd {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            transition: all 0.2s ease 0.6s;
            align-self: center;
            position: relative;
            padding-top: 0px;
            padding-left: 0px;
            padding-right: 0px;
            margin-bottom: 30px;
            h2 {
              font-size: 2.6rem;
              color: #41444c;
              letter-spacing: 1px;
              line-height: 1;
              margin-bottom: 20px;
            }
            p {
              display: none;
            }
          }
          .grid__jd__wrap {
            overflow-x: auto;
            overflow-y: hidden;
            white-space: nowrap;
            padding-left: 0px;
            &::-webkit-scrollbar {
              display: none;
            }
          }
          .grid__jd__item {
            display: inline-block;
            width: 440px;
            margin-right: 40px;
            transition: all 0.2s ease 0.8s;
            position: relative;
            font-weight: 300;
            font-size: 54px;
            color: #000000;
            letter-spacing: 2px;
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .step {
          position: relative;
          display: grid;
          width: 100%;
          grid-template-rows: repeat(1, 600px);
          grid-template-columns: repeat(3, 440px);
          grid-auto-rows: 600px;
          grid-auto-columns: 680px;
          grid-gap: 30px;
          align-content: start;
          justify-content: center;
          margin-top: 0;
          max-width: 1440px;
          margin-bottom: 140px;
          .step__title {
            grid-area: 1 / 1 / 2 / 2;
            position: relative;
            h4 {
              font-size: 2.6rem;
              color: #41444c;
              letter-spacing: 1px;
              line-height: 1;
              margin-bottom: 20px;
            }
            h6 {
              font-weight: 400;
              font-size: 1.4rem;
              color: #70798f;
              letter-spacing: 0.6px;
              line-height: 2;
              margin-bottom: 60px;
            }
            p {
              font-weight: 400;
              font-size: 1.2rem;
              color: #838999;
              letter-spacing: 0.6px;
              line-height: 2;
              padding-right: 100px;
              text-align: justify;
            }
          }
          .step__item {
            position: relative;
            border: 2px solid #f5f5f5;
            border-radius: 20px;
            padding: 40px;
            .pc {
              display: block;
            }
            .mb {
              display: none;
            }
            a {
              display: inline-block;
              font-size: 1.4rem;
              font-weight: bold;
              line-height: 1;
              color: #ffffff;
              letter-spacing: 1px;
              padding: 16px 30px;
              margin-right: 30px;
              margin-top: 30px;
              background: #004bff;
              border-radius: 12px;
              transition: all 0.15s ease;
              &:hover {
                opacity: 1;
                color: #fff;
                background: #000;
              }
            }
          }
          .step__item:nth-child(2) {
            grid-area: 1 / 2 / 2 / 4;
          }
          .step__item:nth-child(3) {
            grid-area: 2 / 2 / 3 / 4;
          }
          .step__item:nth-child(4) {
            grid-area: 3 / 2 / 4 / 4;
          }
          .step__item:nth-child(5) {
            grid-area: 4 / 2 / 5 / 4;
          }
        }
        .coursebag {
          position: relative;
          display: grid;
          width: 100%;
          grid-template-rows: repeat(1, 680px);
          grid-template-columns: repeat(3, 450px);
          grid-auto-rows: 680px;
          grid-auto-columns: 450px;
          grid-gap: 30px;
          align-content: start;
          justify-content: center;
          margin-top: 0;
          max-width: 1440px;
          margin-bottom: 180px;
          .coursebag__title {
            grid-area: 1 / 1 / 2 / 2;
            position: relative;
            h4 {
              font-size: 2.6rem;
              color: #41444c;
              letter-spacing: 1px;
              line-height: 1;
              margin-bottom: 20px;
            }
            h6 {
              font-weight: 400;
              font-size: 1.4rem;
              color: #70798f;
              letter-spacing: 0.6px;
              line-height: 2;
              margin-bottom: 60px;
            }
            p {
              font-weight: 400;
              font-size: 1.2rem;
              color: #838999;
              letter-spacing: 0.6px;
              line-height: 2;
              padding-right: 100px;
              text-align: justify;
            }
          }
          .coursebag__item {
            position: relative;
            border: 2px solid #f5f5f5;
            border-radius: 20px;
            padding: 40px;
            a {
              display: inline-block;
              font-size: 1.2rem;
              font-weight: bold;
              line-height: 1;
              color: #ffffff;
              letter-spacing: 1px;
              padding: 14px 20px;
              margin-right: 20px;
              margin-top: 20px;
              background: #004bff;
              border-radius: 12px;
              transition: all 0.15s ease;
              &:hover {
                opacity: 1;
                color: #fff;
                background: #000;
              }
            }
          }
          .coursebag__item:nth-child(2) {
            grid-area: 1 / 2 / 2 / 3;
          }
          .coursebag__item:nth-child(3) {
            grid-area: 1 / 3 / 2 / 4;
          }
          .coursebag__item:nth-child(4) {
            grid-area: 2 / 2 / 3 / 3;
          }
          .coursebag__item:nth-child(5) {
            grid-area: 2 / 3 / 3 / 4;
          }
          .coursebag__item:nth-child(6) {
            grid-area: 3 / 2 / 4 / 3;
          }
          .coursebag__item:nth-child(7) {
            grid-area: 3 / 3 / 4 / 4;
          }
        }
        .buybuybuy {
          width: 100%;
          height: 350px;
          background: #f5f5f5;
          border-radius: 20px;
          margin-bottom: 200px;
          padding: 10px 100px;
          position: relative;
          h2 {
            font-weight: 400;
            font-size: 2.6rem;
            color: #42454d;
            letter-spacing: 3px;
            text-align: left;
            line-height: 1;
            margin-top: 60px;
          }
          h4 {
            font-weight: 300;
            font-size: 28px;
            color: #99a0b2;
            letter-spacing: 1.12px;
            line-height: 2;
            margin-top: 60px;
          }
          h5 {
            font-weight: 300;
            font-size: 2rem;
            color: #99a0b2;
            letter-spacing: 1.12px;
            line-height: 2;
            a {
              display: inline-block;
              font-weight: bold;
              padding: 10px 16px 10px;
              font-size: 2rem;
              line-height: 1;
              color: #ff6f61;
              background: #fff;
              border-radius: 8px;
              &:hover {
                color: #fff;
                background: #ff6f61;
              }
            }
            span {
              font-family: SourceHanSansCN-Heavy;
              font-size: 2rem;
              line-height: 1;
              color: #ff6f61;
            }
          }
          img {
            width: 35%;
            position: absolute;
            right: 0;
            bottom: 0;
            margin-right: 50px;
          }
        }
      }
    }

    .page--preview .content {
      opacity: 0 !important;
      transition: none !important;
    }

    .js.content {
      opacity: 1;
      transition: all 0.3s ease 0.6s;
    }

    .js .content__item {
      position: absolute;
      top: 0;
      opacity: 0;
      pointer-events: none;
      height: 100vh;
      overflow: hidden;
    }

    .js .content__item--current {
      position: relative;
      opacity: 1;
      pointer-events: auto;
      height: auto;
    }

    .page--preview {
      position: relative;
      overflow: hidden;
      height: 100vh;
    }

    @media screen and (min-width: 53em) {
      .frame {
        position: fixed;
        text-align: left;
        display: grid;
        align-content: space-between;
        max-width: none;
        height: 100vh;
        padding: 2rem;
        pointer-events: none;
        grid-template-columns: 50% 50%;
        grid-template-rows: auto auto auto;
        grid-template-areas:
          "pageheader menutop"
          "... ..."
          "... codropsheader";
      }
      .codrops-header {
        grid-area: codropsheader;
        padding: 0;
        justify-self: end;
        text-align: right;
      }
      .codrops-links {
        margin: 0;
      }
      .frame a {
        pointer-events: auto;
      }
      .pageheader {
        grid-area: pageheader;
        margin: 0;
      }
      .menutop {
        grid-area: menutop;
        justify-self: end;
        width: 100%;
        display: grid;
        grid-template-rows: 100%;
        grid-auto-flow: column;
        justify-content: end;
        grid-gap: 1rem;
      }
      .menutop__item:nth-child(2) {
        margin: 0 2rem 0 0;
      }
      .menu {
      }
      // .menu__item-number {
      //   display: block;
      // }
      // .menu__item-text {
      //   font-size: 8vh;
      // }
      // .gridwrap {
      //   grid-gap: 3rem;
      //   padding: 2rem 5vw;
      // }
      // .grid {
      //   --gridheight: 1100px;
      // }
      // .content__item {
      //   font-size: 1.5rem;
      //   padding: 10vh 1rem;
      // }
    }
  }
  @media (min-width: 1230px) and (max-width: 1470px) {
    .page-path {
      main.main-path {
        .path-header {
          width: 1170px;
          left: calc((100% - 1170px) / 2);
          .headerNav .headerNav__item {
            padding: 0 20px;
          }
        }
      }
      .menu__item .menu__item-number {
        width: 66px;
        height: 66px;
      }
      .menu__item-textwrap {
        .menu__item-text {
          font-size: 7rem;
        }
        .menu__item-text-ZH {
          font-size: 3.4rem;
          top: 1.1rem;
        }
      }
      .gridwrap {
        max-width: 1170px;
      }
      .grid {
        --gridheight: 1280px;
        height: var(--gridheight);
        grid-template-rows: repeat(16, calc(var(--gridheight) / 16 - var(--gridgap)));
        grid-template-columns: repeat(12, 70px);
        .grid__title {
          h2 {
            font-size: 52px;
          }
          h3 {
            font-size: 76px;
          }
          .path-icon {
            width: 66px;
            height: 66px;
          }
          p {
            font-size: 18px;
            letter-spacing: 0.8px;
            padding-right: 70px;
          }
        }
        .grid__item p {
          font-size: 18px;
          letter-spacing: 0.8px;
          bottom: -33px;
        }
        .grid__jd:nth-child(9) {
          font-size: 40px;
          letter-spacing: 2px;
          padding-top: 50px;
        }
        .grid__jd__item:nth-child(10) {
          grid-area: 11 / 1 / 18 / 5;
        }
        .grid__jd__item:nth-child(11) {
          grid-area: 11 / 5 / 18 / 9;
        }
        .grid__jd__item:nth-child(12) {
          grid-area: 11 / 9 / 18 / 13;
        }
      }
      .content .content__item {
        .step {
          max-width: 1170px;
          margin: 0 auto;
          grid-template-rows: repeat(3, 480px);
          grid-template-columns: repeat(2, 570px);
          grid-auto-rows: 480px;
          grid-auto-columns: 570px;
          margin-bottom: 140px;
          .step__title {
            padding-top: 30px;
            h4 {
              font-size: 36px;
              margin-bottom: 40px;
            }
            p {
              font-size: 18px;
              padding-right: 80px;
            }
          }
          .step__item a {
            font-size: 18px;
            margin-right: 20px;
            padding: 8px 15px 10px;
          }
          &:after {
            width: 570px;
          }
        }
        .coursebag {
          max-width: 1170px;
          margin: 0 auto;
          grid-template-rows: repeat(2, 270px);
          grid-template-columns: repeat(3, 370px);
          grid-auto-rows: 270px;
          grid-auto-columns: 370px;
          margin-bottom: 140px;
          .coursebag__title {
            padding-top: 30px;
            h4 {
              font-size: 36px;
              margin-bottom: 40px;
            }
            p {
              font-size: 18px;
              padding-right: 30px;
            }
          }
          .coursebag__item a {
            font-size: 18px;
            margin-right: 20px;
            padding: 8px 15px 10px;
          }
          &:after {
            width: 370px;
          }
        }
        .buybuybuy {
          height: 300px;
          h2 {
            font-size: 36px;
            letter-spacing: 2.4px;
            line-height: 1;
            margin-top: 50px;
          }
          h4 {
            font-size: 28px;
            line-height: 2;
            margin-top: 40px;
          }
          h5 {
            font-size: 28px;
            line-height: 2;
            a {
              padding: 5px 16px 12px;
              font-size: 32px;
            }
            span {
              font-size: 36px;
            }
          }
          img {
            width: 35%;
            margin-right: 50px;
          }
        }
      }
    }
  }
  @media (min-width: 980px) and (max-width: 1229px) {
    .page-path {
      main.main-path {
        .path-header {
          width: 940px;
          height: 60px;
          top: 140px;
          left: calc((100% - 940px) / 2);
          .left {
            h2 {
              font-size: 2rem;
            }
            .gridback {
              font-size: 1rem;
              color: #000000;
              letter-spacing: 1px;
              border: 1px solid rgba(0, 0, 0, 0.08);
              background: transparent;
              padding: 4px 12px 6px;
              cursor: pointer;
              opacity: 0;
              -webkit-transition: all 0.15s;
              transition: all 0.15s;
            }
          }
          .headerNav .headerNav__item {
            padding: 0 15px;
            line-height: 58px;
            border: 0;
            font-size: 14px;
            color: #000000;
            letter-spacing: 0.4px;
          }
        }
      }
      .menu__item .menu__item-number {
        width: 58px;
        height: 58px;
      }
      .menu__item-textwrap {
        .menu__item-text {
          font-size: 6rem;
        }
        .menu__item-text-ZH {
          font-size: 3rem;
          top: 0.9rem;
        }
      }
      .menu__item-link {
        font-size: 1.2rem;
        padding: 8px 10px 10px;
        right: -9rem;
        &::after {
          right: -17px;
          border-left: solid 17px #011fff;
          border-bottom: solid 17px transparent;
          border-top: solid 17px transparent;
        }
      }
      .gridwrap {
        max-width: 940px;
      }
      .grid {
        --gridgap: 20px;
        grid-gap: var(--gridgap);
        --gridheight: 1050px;
        height: var(--gridheight);
        grid-template-rows: repeat(16, calc(var(--gridheight) / 16 - var(--gridgap)));
        grid-template-columns: repeat(12, 60px);
        .grid__title {
          h2 {
            font-size: 44px;
          }
          h3 {
            font-size: 62px;
          }
          .path-icon {
            width: 52px;
            height: 52px;
          }
          p {
            font-size: 14px;
            letter-spacing: 0.4px;
            padding-right: 60px;
          }
        }
        .grid__item {
          margin-top: 10px;
          margin-bottom: 20px;
        }
        .grid__item p {
          font-size: 14px;
          letter-spacing: 0.8px;
          bottom: -26px;
        }
        .grid__jd:nth-child(9) {
          font-size: 32px;
          letter-spacing: 2px;
          padding-top: 50px;
        }
        .grid__jd__item:nth-child(10) {
          grid-area: 11 / 1 / 18 / 5;
        }
        .grid__jd__item:nth-child(11) {
          grid-area: 11 / 5 / 18 / 9;
        }
        .grid__jd__item:nth-child(12) {
          grid-area: 11 / 9 / 18 / 13;
        }
      }
      .content .content__item {
        .step {
          max-width: 940px;
          margin: 0 auto;
          grid-gap: 20px;
          grid-template-rows: repeat(3, 410px);
          grid-template-columns: repeat(2, 460px);
          grid-auto-rows: 410px;
          grid-auto-columns: 460px;
          margin-bottom: 140px;
          .step__title {
            padding-top: 20px;
            h4 {
              font-size: 28px;
              margin-bottom: 20px;
            }
            p {
              font-size: 14px;
              padding-right: 100px;
            }
          }
          .step__item a {
            font-size: 14px;
            margin-right: 12px;
            padding: 6px 10px 8px;
          }
          &:after {
            width: 460px;
          }
        }
        .coursebag {
          max-width: 940px;
          margin: 0 auto;
          grid-gap: 20px;
          grid-template-rows: repeat(2, 220px);
          grid-template-columns: repeat(3, 300px);
          grid-auto-rows: 220px;
          grid-auto-columns: 300px;
          margin-bottom: 140px;
          .coursebag__title {
            padding-top: 30px;
            h4 {
              font-size: 28px;
              margin-bottom: 20px;
            }
            p {
              font-size: 14px;
              padding-right: 30px;
            }
          }
          .coursebag__item a {
            font-size: 14px;
            margin-right: 12px;
            padding: 6px 10px 8px;
          }
          &:after {
            width: 300px;
          }
        }
        .buybuybuy {
          height: 270px;
          h2 {
            font-size: 34px;
            letter-spacing: 2px;
            line-height: 1;
            margin-top: 50px;
          }
          h4 {
            font-size: 24px;
            line-height: 2;
            margin-top: 40px;
          }
          h5 {
            font-size: 24px;
            line-height: 2;
            a {
              padding: 5px 16px 8px;
              font-size: 28px;
            }
            span {
              font-size: 32px;
            }
          }
          img {
            width: 40%;
            margin-right: 10px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 979px) {
    .page-path {
      main.main-path {
        .path-header {
          width: 750px;
          height: 50px;
          top: 120px;
          left: calc((100% - 750px) / 2);
          .left {
            h2 {
              font-size: 1.6rem;
            }
            .gridback {
              font-size: 12px;
              color: #000000;
              letter-spacing: 1px;
              border: 1px solid rgba(0, 0, 0, 0.08);
              background: transparent;
              padding: 3px 8px 4px;
              cursor: pointer;
              opacity: 0;
              -webkit-transition: all 0.15s;
              transition: all 0.15s;
            }
          }
          .headerNav .headerNav__item {
            padding: 0 10px;
            line-height: 48px;
            border: 0;
            font-size: 12px;
            color: #000000;
            letter-spacing: 0.4px;
          }
        }
      }
      .menu__item {
        margin: 0.5rem 0;
        .menu__item-number {
          width: 48px;
          height: 48px;
        }
      }
      .menu__item-textwrap {
        .menu__item-text {
          font-size: 5rem;
        }
        .menu__item-text-ZH {
          font-size: 2.4rem;
          top: 0.8rem;
        }
      }
      .menu__item-link {
        width: auto;
        font-size: 1rem;
        padding: 7px 10px 9px;
        right: -7rem;
        &::after {
          right: -15px;
          border-left: solid 15px #011fff;
          border-bottom: solid 15px transparent;
          border-top: solid 15px transparent;
        }
      }
      .gridwrap {
        max-width: 750px;
        padding-top: 120px;
      }
      .grid {
        --gridgap: 20px;
        grid-gap: var(--gridgap);
        --gridheight: 880px;
        height: var(--gridheight);
        grid-template-rows: repeat(16, calc(var(--gridheight) / 16 - var(--gridgap)));
        grid-template-columns: repeat(12, 44px);
        .grid__title {
          h2 {
            font-size: 32px;
          }
          h3 {
            font-size: 48px;
          }
          .path-icon {
            width: 44px;
            height: 44px;
          }
          p {
            font-size: 12px;
            letter-spacing: 0.2px;
            padding-right: 40px;
          }
        }
        .grid__item {
          margin-top: 0px;
          margin-bottom: 20px;
        }
        .grid__item p {
          font-size: 12px;
          letter-spacing: 0.2px;
          bottom: -22px;
        }
        .grid__jd:nth-child(9) {
          font-size: 26px;
          letter-spacing: 2px;
          padding-top: 30px;
        }
        .grid__jd__item:nth-child(10) {
          grid-area: 11 / 1 / 18 / 5;
        }
        .grid__jd__item:nth-child(11) {
          grid-area: 11 / 5 / 18 / 9;
        }
        .grid__jd__item:nth-child(12) {
          grid-area: 11 / 9 / 18 / 13;
        }
      }
      .content .content__item {
        .step {
          max-width: 750px;
          margin: 0 auto;
          grid-gap: 20px;
          grid-template-rows: repeat(3, 330px);
          grid-template-columns: repeat(2, 365px);
          grid-auto-rows: 320px;
          grid-auto-columns: 365px;
          margin-bottom: 140px;
          .step__title {
            padding-top: 20px;
            h4 {
              font-size: 22px;
              margin-bottom: 16px;
            }
            p {
              font-size: 12px;
              padding-right: 100px;
            }
          }
          .step__item a {
            font-size: 12px;
            margin-right: 10px;
            padding: 6px 10px 8px;
          }
          &:after {
            width: 365px;
          }
        }
        .coursebag {
          max-width: 750px;
          margin: 0 auto;
          grid-gap: 20px;
          grid-template-rows: repeat(2, 190px);
          grid-template-columns: repeat(3, 237px);
          grid-auto-rows: 190px;
          grid-auto-columns: 237px;
          margin-bottom: 140px;
          .coursebag__title {
            padding-top: 30px;
            h4 {
              font-size: 22px;
              margin-bottom: 16px;
            }
            p {
              font-size: 12px;
              padding-right: 30px;
            }
          }
          .coursebag__item a {
            font-size: 12px;
            margin-right: 10px;
            padding: 6px 10px 8px;
          }
          &:after {
            width: 237px;
          }
        }
        .buybuybuy {
          height: 218px;
          h2 {
            font-size: 30px;
            letter-spacing: 2px;
            line-height: 1;
            margin-top: 40px;
          }
          h4 {
            font-size: 20px;
            line-height: 2;
            margin-top: 30px;
          }
          h5 {
            font-size: 20px;
            line-height: 1;
            a {
              padding: 5px 12px 8px;
              font-size: 24px;
            }
            span {
              font-size: 28px;
            }
          }
          img {
            width: 40%;
            margin-right: 10px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .page-path {
      background: #ffffff;
      main.main-path {
        position: relative;
        width: 100%;
        .path-header {
          width: 100%;
          padding: 0 15px;
          height: 163px;
          margin: 0 auto;
          margin-top: 0px;
          position: absolute;
          z-index: 9999;
          left: 0;
          top: 0;
          opacity: 0;
          transition: all 0.2s ease 0s;
          display: block;
          &.show {
            opacity: 1;
            transition: all 0.2s ease 0.5s;
          }
          .left {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px 0 5px;
            border-bottom: 1px solid #f5f5f5;
            h2 {
              font-size: 24px;
              font-weight: 300;
              line-height: 44px;
              margin: 0px;
            }
            .gridback {
              font-family: SourceHanSansCN-Heavy;
              font-size: 14px;
              color: #000000;
              letter-spacing: 1px;
              border: 1px solid rgba(0, 0, 0, 0.08);
              background: transparent;
              padding: 4px 12px 6px;
              cursor: pointer;
              opacity: 0;
              transition: all 0.15s;
              outline: 0;
              background: rgba(0, 0, 0, 0.05);
            }
            .gridback.show {
              opacity: 1;
            }
          }
          .headerNav {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            .headerNav__item {
              display: block;
              width: 50%;
              line-height: 36px;
              border: 0;
              padding: 0;
              font-size: 12px;
              color: #000000;
              letter-spacing: 1px;
              text-align: center;
              background: rgba(0, 0, 0, 0);
              transition: all 0.2s;
              outline: 0;
              margin-bottom: 5px;
            }
          }
        }
      }

      .path-popup {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.75);
        z-index: -1;
        opacity: 0;
        transition: all 0.2s;
        .popupwindow {
          width: 90vw;
          max-width: 500px;
          position: relative;
          img {
            width: 100%;
          }
          .popup-close {
            position: absolute;
            right: 15px;
            top: 15px;
            border: 0;
            font-size: 20px;
            line-height: 16px;
            font-weight: 200;
            padding: 8px;
            color: rgba(0, 0, 0, 0.3);
            background: #f5f5f5;
            border-radius: 12px;
            cursor: pointer;
          }
        }

        &.show {
          opacity: 1;
          z-index: 99999;
        }
      }

      .frame {
        padding: 2rem 1rem 0;
        text-align: center;
        position: absolute;
        z-index: 10000;
        top: 0;
        left: 0;
        width: 100%;
      }

      /* Header */
      .codrops-header {
        position: relative;
        z-index: 100;
      }

      .codrops-header__links a {
        display: inline-block;
        text-transform: lowercase;
      }

      .codrops-header__links a:nth-child(2) {
        margin: 0 0.5rem;
      }

      .codrops-header__title {
        font-size: 1rem;
        line-height: 1;
        margin: 0 0 0.75rem 0;
      }

      .pageheader {
        font-size: 1rem;
        margin: 1rem 0;
      }

      .menutop__item {
        pointer-events: auto;
        font-weight: bold;
        cursor: pointer;
        margin: 0 0.5rem;
      }

      .menutop__item--social {
        color: #323232;
      }

      .menu {
        position: fixed;
        top: 9.6875rem;
        left: 0;
        width: 100%;
        height: calc(100% - 9.6875rem);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        pointer-events: none;
        top: 0;
        height: 100%;
      }

      .menu__item {
        position: relative;
        width: 100vw;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        pointer-events: auto;
        margin: 1rem 0;
      }

      .menu--closed .menu__item {
        pointer-events: none;
      }

      .menu--closed .menu__item--current .menu__item-link {
        opacity: 0;
      }

      .menu__item-textwrap {
        position: relative;
        overflow: hidden;
        width: 100vw;
        height: 116px;
        line-height: 1;
        margin: 0;
        .menu__item-text {
          position: absolute;
          top: 0;
          height: 100px;
          font-family: "cobe-heavy";
          font-size: 6rem;
          line-height: 6rem;
          z-index: 2;
          opacity: 1;
          .menu__item-text-outline {
            position: absolute;
            top: 0;
            -webkit-text-stroke: 1px #f2f3f5;
            -webkit-text-fill-color: transparent;
            display: inline-block;
            width: 100vw;
            text-align: center;
          }
          .loop-holder {
            display: flex;
            white-space: nowrap;
            overflow: hidden;
            opacity: 0;
            .loop-holder__text {
              animation: textLoop 20s linear infinite;
              font-size: 6rem;
              padding-right: 0.2em;
              color: #f2f3f5;
            }
            @keyframes textLoop {
              0% {
                -webkit-transform: translate3d(0, 0, 0);
                transform: translate3d(0, 0, 0);
              }
              100% {
                -webkit-transform: translate3d(-100%, 0, 0);
                transform: translate3d(-100%, 0, 0);
              }
            }
          }
        }
        .menu__item-text-ZH {
          width: 100vw;
          margin: 0 auto;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 3;
          height: 100px;
          text-align: center;
          .text {
            width: 100vw;
            position: absolute;
            top: 0;
            left: 0;
            text-align: center;
            font-size: 36px;
            line-height: 6rem;
          }
          .menu__item-number {
            display: none;
          }
          .menu__item-link {
            position: absolute;
            right: calc(50vw - 66px);
            top: 75px;
            background: #ff6f61;
            color: #fff !important;
            font-size: 1rem;
            font-weight: bold;
            line-height: 1;
            padding: 10px 24px 10px;
            border-radius: 8px;
            opacity: 0;
            width: auto;
            cursor: pointer;
            text-align: center;
            transform: translateX(-20px);
            transition: all 0.3s ease 0s;
          }
        }
        &:hover {
          cursor: pointer;
          .menu__item-text-ZH {
            .menu__item-number {
              opacity: 0.1;
            }
            .text {
              -webkit-text-stroke: 0;
              -webkit-text-fill-color: #838999;
            }
          }
        }
      }
      .menu__item--current {
        .menu__item-text {
          .menu__item-text-outline {
            opacity: 0;
          }
          .loop-holder {
            opacity: 1;
          }
        }
        .menu__item-text-ZH {
          .menu__item-number {
            opacity: 1;
          }
          .text {
            -webkit-text-stroke: 0;
            -webkit-text-fill-color: #004bff;
          }
          .menu__item-link {
            opacity: 1;
            transform: translateX(0px);
          }
        }
        &:hover {
          cursor: pointer;
          .menu__item-text-ZH {
            .menu__item-number {
              opacity: 1;
            }
            .text {
              -webkit-text-stroke: 0;
              -webkit-text-fill-color: #004bff;
            }
          }
        }
      }

      .gridwrap {
        display: grid;
        max-width: 100%;
        margin: 0 auto;
        padding-top: 0px;
        grid-template-columns: 100%;
        grid-template-rows: 1.75rem calc(100% - 1.75rem);
        place-items: center;
        position: relative;
        pointer-events: none;
        padding: 0 15px;
      }

      .grid--open ~ .gridback {
        pointer-events: auto;
      }

      .grid {
        padding-top: 180px;
        grid-area: 1 / 1 / 3 / 2;

        display: grid;
        width: 100vw;
        height: 1000px;
        grid-template-rows: repeat(15, 40px);
        grid-template-columns: repeat(3, calc((100vw - (15px * 4)) / 3));
        grid-auto-rows: 40px;
        grid-auto-columns: calc((100vw - (15px * 3)) / 2);
        grid-gap: 15px;
        align-content: start;
        justify-content: center;
        margin-top: 0;
      }

      .grid__item {
        opacity: 0;
        position: relative;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: cover;
        margin-bottom: 24px;
        p {
          font-weight: 300;
          font-size: 16px;
          color: #000000;
          letter-spacing: 1px;
          position: absolute;
          bottom: -28px;
          opacity: 0;
          transform: translateY(20px);
          transition: all 0.2s ease 0.4s;
        }
      }

      .grid--open .grid__item {
        pointer-events: auto;
        border-radius: 4px;
      }

      .grid__item::after {
        content: "";
        background: rgba(255, 255, 255, 0.8);
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        transition: background 1s cubic-bezier(1, 0, 0, 1);
      }
      .page--preview {
        .gridwrap {
          padding: 0;
        }
        .grid {
          overflow: auto;
        }
      }

      .grid {
        width: 100%;
        overflow: hidden;
        .grid__title {
          opacity: 0;
          transform: translateY(20px);
          transition: all 0.2s ease 0.4s;
          grid-area: 5 / 1 / 12 / 4;
          position: relative;
          width: 100%;
          overflow: hidden;
          h2 {
            font-family: SourceHanSansCN-Heavy;
            font-size: 32px;
            color: #001fff;
            letter-spacing: 1px;
            line-height: 1;
            margin-bottom: 5px;
            color: #004bff;
            span {
              color: #42454d;
            }
          }
          h3 {
            margin-top: 10px;
            margin-bottom: 20px;
            color: #f2f3f5;
            font-family: "cobe-heavy";
            font-size: 30px;
            line-height: 1;
            letter-spacing: 0;
          }
          .path-icon {
            width: 32px;
            height: 32px;
            align-self: center;
            background-size: cover;
            position: absolute;
            top: 0px;
            right: 0px;
            transition: all 0.15s 0.1s;
            svg {
              width: 32px;
              height: 32px;
            }
          }
          p {
            font-weight: 300;
            font-size: 15px;
            color: #42454d;
            letter-spacing: 0.6px;
            text-align: justify;
            line-height: 2;
            padding-right: 0px;
          }
        }
        .grid__item:nth-child(2) {
          grid-area: 1 / 1 / 5 / 4;
          margin-top: 0px;
          margin-bottom: 0px;
          border-radius: 16px;
        }
        .grid__item:nth-child(3) {
          grid-area: 12 / 1 / 14 / 2;
          border-radius: 12px;
        }
        .grid__item:nth-child(4) {
          grid-area: 12 / 2 / 14 / 3;
          border-radius: 12px;
        }
        .grid__item:nth-child(5) {
          grid-area: 12 / 3 / 14 / 4;
          border-radius: 12px;
        }
        .grid__item:nth-child(6) {
          grid-area: 14 / 1 / 16 / 2;
          border-radius: 12px;
        }
        .grid__item:nth-child(7) {
          grid-area: 14 / 2 / 16 / 3;
          border-radius: 12px;
        }
        .grid__item:nth-child(8) {
          grid-area: 14 / 3 / 16 / 4;
          border-radius: 12px;
        }
      }

      .grid--open {
        .grid__item p {
          opacity: 1;
          transform: translateY(0);
        }
        .grid__item::after {
          background: rgba(0, 0, 0, 0);
        }
        .grid__title {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .content {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        min-height: 60vh;
        padding-top: 0px;
        overflow: visible;
        .content__item {
          width: 100%;
          .jd {
            width: 100%;
            margin-bottom: 60px;
            max-width: 100vw;
            .grid__jd {
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              transition: all 0.2s ease 0.6s;
              align-self: center;
              position: relative;
              padding-top: 50px;
              padding-left: 15px;
              padding-right: 15px;
              margin-bottom: 20px;
              h2 {
                font-weight: 300;
                font-size: 24px;
                color: #42454d;
                margin-bottom: 0;
              }
              p {
                display: block;
                opacity: 0.3;
                font-weight: 300;
                font-size: 14px;
                color: #42454d;
                letter-spacing: 0.35px;
              }
            }
            .grid__jd__wrap {
              overflow-x: auto;
              overflow-y: hidden;
              white-space: nowrap;
              padding-left: 15px;
              padding-right: 15px;
              &::-webkit-scrollbar {
                display: none;
              }
            }
            .grid__jd__item {
              display: inline-block;
              width: 70vw;
              margin-right: 15px;
              transition: all 0.2s ease 0.8s;
              position: relative;
              font-weight: 300;
              font-size: 54px;
              color: #000000;
              letter-spacing: 2px;
            }
          }
          .step {
            position: relative;
            width: 100%;
            margin-top: 0;
            margin-bottom: 60px;
            padding: 0 15px;
            max-width: 100%;
            display: block;
            .step__title {
              position: relative;
              padding-top: 20px;
              padding-bottom: 40px;
              h4 {
                color: #41444c;
                font-size: 24px;
                letter-spacing: 1px;
                line-height: 1;
                margin-bottom: 10px;
              }
              h6 {
                color: #70798f;
                font-weight: 300;
                font-size: 14px;
                letter-spacing: 0.6px;
                line-height: 2;
                text-align: justify;
                margin-bottom: 30px;
              }
              p {
                color: #838999;
                font-weight: 300;
                font-size: 14px;
                letter-spacing: 0.6px;
                line-height: 2;
                text-align: justify;
                padding-right: 0;
              }
            }
            .step__item {
              position: relative;
              border: 2px solid #f5f5f5;
              border-radius: 20px;
              padding: 20px;
              margin-bottom: 20px;
              .pc {
                display: none;
              }
              .mb {
                display: block;
              }
              a {
                display: inline-block;
                font-size: 14px;
                line-height: 1;
                font-weight: bold;
                color: #ffffff;
                letter-spacing: 1px;
                padding: 12px 18px;
                margin-right: 10px;
                margin-top: 20px;
                background: #004bff;
                border-radius: 8px;
                transition: all 0.15s ease;
              }
            }
          }
          .coursebag {
            position: relative;
            width: 100%;
            margin-top: 0;
            margin-bottom: 60px;
            padding: 0 15px;
            max-width: 100%;
            display: block;
            .coursebag__title {
              position: relative;
              padding-top: 20px;
              padding-bottom: 40px;
              h4 {
                color: #41444c;
                font-size: 24px;
                letter-spacing: 1px;
                line-height: 1;
                margin-bottom: 10px;
              }
              h6 {
                color: #70798f;
                font-weight: 300;
                font-size: 14px;
                letter-spacing: 0.6px;
                line-height: 2;
                text-align: justify;
                margin-bottom: 30px;
              }
              p {
                color: #838999;
                font-weight: 300;
                font-size: 14px;
                letter-spacing: 0.6px;
                line-height: 2;
                text-align: justify;
                padding-right: 0;
              }
            }
            .coursebag__item {
              position: relative;
              border: 2px solid #f5f5f5;
              border-radius: 20px;
              padding: 20px;
              margin-bottom: 20px;
              a {
                display: inline-block;
                font-size: 14px;
                line-height: 1;
                font-weight: bold;
                color: #ffffff;
                letter-spacing: 1px;
                padding: 12px 18px;
                margin-right: 10px;
                margin-top: 20px;
                background: #004bff;
                border-radius: 8px;
                transition: all 0.15s ease;
              }
            }
          }
          .buybuybuy {
            width: calc(100vw - 30px);
            height: 400px;
            background: #f5f5f5;
            border-radius: 20px;
            margin-bottom: 200px;
            padding: 10px 15px;
            position: relative;
            margin: 0 15px 80px;
            h2 {
              font-weight: 400;
              font-size: 20px;
              color: #42454d;
              letter-spacing: 2px;
              text-align: center;
              line-height: 1;
              margin-top: 30px;
            }
            h4 {
              font-weight: 300;
              font-size: 16px;
              color: #99a0b2;
              letter-spacing: 0.6px;
              line-height: 2;
              margin-top: 20px;
              text-align: center;
            }
            h5 {
              font-weight: 300;
              font-size: 16px;
              color: #99a0b2;
              letter-spacing: 0.6px;
              line-height: 2;
              width: 50vw;
              margin: 0 auto;
              text-align: center;
              a {
                display: inline-block;
                font-weight: bold;
                padding: 8px 14px;
                font-size: 18px;
                line-height: 1;
                color: #ff6f61;
                background: #fff;
                border-radius: 8px;
                &:hover {
                  color: #fff;
                  background: #ff6f61;
                }
              }
              span {
                font-family: SourceHanSansCN-Heavy;
                font-size: 18px;
                line-height: 1;
                color: #ff6f61;
              }
            }
            img {
              width: 60vw;
              position: absolute;
              right: 17vw;
              bottom: 0;
              margin-right: 0px;
            }
          }
        }
      }

      .page--preview .content {
        opacity: 0 !important;
        transition: none !important;
      }

      .js.content {
        opacity: 1;
        transition: all 0.3s ease 0.6s;
      }

      .js .content__item {
        position: absolute;
        top: 0;
        opacity: 0;
        pointer-events: none;
        height: 100vh;
        overflow: hidden;
      }

      .js .content__item--current {
        position: relative;
        opacity: 1;
        pointer-events: auto;
        height: auto;
      }

      .page--preview {
        position: relative;
        overflow: hidden;
        height: 100vh;
      }
    }
  }
</style>